/* HOPER · catalogue professionnel, version allemande du moteur.
   Fichier GENERE par outils/catalogue_allemand.py : ne pas le modifier a la
   main, la prochaine generation ecraserait la correction. Toucher au
   francais, puis relancer le script.
   empreinte-source: 6f0d3722a8ef48ae */
  (function () {
    /* Depuis le 03/09/2026 cette page est reservee aux comptes B2B connectes :
       Shopify rend donc deja le prix professionnel dans le prix de la variante. Multiplier
       encore par 0,85 remisait une seconde fois, le total ne correspondait plus a
       celui que Shopify calcule sur la commande provisoire, et TOUT paiement etait
       refuse avec « Un imprevu technique est survenu ». Verifie le 04/09 sur le
       CYCAS P.324 45cm : public 36,00 TTC, affiche 30,60 en connecte.
       12/09/2026 : le catalogue s'ouvre sans compte. Shopify rend alors le prix
       PUBLIC a un visiteur anonyme et le prix PRO a un compte ouvert. REMISE_PRO
       sert donc a deux choses, et a deux seulement : appliquer la remise pour un
       visiteur anonyme, et retrouver le prix public de reference pour un compte
       ouvert. Toute troisieme utilisation serait une remise en double. */
    var REMISE_PRO = 0.85;
    /* 12/09/2026 : le catalogue est ouvert a tout le monde. PRO dit si le prix
       rendu par Shopify est deja le tarif professionnel. */
    var PRO = !!(window.HOPER_CFG && window.HOPER_CFG.pro);
    var VAT = 0.20;
    /* Le seuil et le tarif palette vivent desormais cote serveur uniquement :
       les avoir des deux cotes, c'etait deux verites possibles pour un seul prix. */
    /* Il n'y a plus de grille d'estimation ici. Celle qui s'y trouvait annoncait
       54,90 pour un panier facture 36,90, et le meme 54,90 pour une livraison en
       Suisse facturee 150,90. Le port vient du serveur, ou n'est pas affiche. */
    var IGNIF = { small: 5000, mid: 8500, tall: 12000 };
    var CODE_API = 'https://hoper-concierge.cs-2e0.workers.dev/pro/code'; /* vérification live des Réductions Shopify */
    var DEVIS_API = 'https://hoper-concierge.cs-2e0.workers.dev/pro/devis'; /* sauvegarde/reprise des devis par numéro (KV) */
    var CHECKOUT_API = 'https://hoper-concierge.cs-2e0.workers.dev/pro/checkout'; /* commande self-service (carte / virement) */
    /* 17/09/2026. L'annuaire public des entreprises est appele DEPUIS LE NAVIGATEUR : il limite
       les appels par adresse, et les adresses de Cloudflare, partagees, etaient refusees trois
       fois sur quatre. Il autorise les appels directs (CORS ouvert). */
    var ANNUAIRE_API = 'https://recherche-entreprises.api.gouv.fr/search';
    /* Raison sociale LEGALE (celle de la facture, jamais le nom avec sigle), siege, TVA
       calculee depuis le SIREN. Entreprises actives seules. */
    function ficheAnnuaire(e){
      if(!e || e.etat_administratif!=='A' || !/^\d{9}$/.test(String(e.siren||''))) return null;
      var s=e.siege||{}, siren=String(e.siren), cle=(12+3*(Number(siren)%97))%97;
      var nom=[e.nom_raison_sociale,e.nom_complet].map(function(x){ return String(x||'').trim(); }).filter(function(x){ return x && x.toLowerCase()!=='none'; })[0]||'';
      return { nom:nom, siren:siren, tva:'FR'+(cle<10?'0':'')+cle+siren,
               adresse:[s.numero_voie,s.type_voie,s.libelle_voie].filter(Boolean).join(' '),
               cp:String(s.code_postal||''), ville:String(s.libelle_commune||'') };
    }
    var MAIL_API = 'https://hoper-concierge.cs-2e0.workers.dev/pro/devis-mail'; /* envoi du devis PDF par email (pro@) */

    var root = document.querySelector('.hcat');
    var bar = document.getElementById('hcat-bar');
    if (!root || !bar) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.hcat-card'));
    var ignifMain = document.getElementById('hcat-ignif');
    var ignifModal = document.getElementById('hcat-ignif-m');
    var modal = document.getElementById('hcat-modal');
    var appliedCode = null;
    /* 17/09/2026. Geste commercial du Comptoir, pose par un associe prouve (le worker ignore
       tout geste venu d'un autre navigateur). Il remplace un code partenaire. */
    var geste = null;
    var majBandeauVendeur = function(){}; /* remplace par le mode vendeur s'il est actif */
    /* 22/09/2026. Ouvre la fiche client du Comptoir sur le premier champ manquant, puis
       reprend l'action interrompue. Remplace par le mode vendeur s'il est actif. */
    var ouvrirFicheAdresse = null;
    /* 22/09/2026, Charles : « cette popup est assez instable, elle disparait souvent ».
       Un geste qui COMMENCE dans la carte (selectionner un nom pour le corriger, glisser
       dans un champ) et se TERMINE sur le fond envoie le clic au parent commun, qui est
       le fond : la fenetre se fermait sous les doigts. On ne ferme plus que si le geste a
       commence ET fini sur le fond. Les huit fenetres du catalogue passent par ici. */
    function surFond(fond, fermer){
      var depart = null;
      fond.addEventListener('pointerdown', function(e){ depart = e.target; });
      fond.addEventListener('click', function(e){
        var parti = depart; depart = null;
        if(e.target === fond && parti === fond) fermer();
      });
    }
    /* 15/10/2026, demande de Charles : une ligne de PRESTATION libre, saisie au Comptoir
       uniquement. Montants en CENTIMES HT, comme tout le reste du moteur.
       Trois regles tenues par le stratege et verifiees dans le worker :
         - elle n'entre ni dans le prix public ni dans le prix pro, c'est un service :
           il ne se remise pas et il ne s'expedie pas, donc il ne pese pas sur le port ;
         - la TVA n'est PAS saisie, elle suit le regime deja calcule pour le devis ;
         - un devis qui en porte une n'est pas payable en ligne, parce que le controle
           de prix du worker compare le total au brouillon Shopify et rejetterait la
           ligne absente. Le vendeur envoie le PDF et encaisse depuis l'admin. */
    var presta = null;              /* {lib, qte, unite, puCents} */
    var PRESTA_PLAFOND = 500000;    /* 5 000 EUR HT : attrape le zero en trop */
    /* Une seule chaine, donc une seule entree de traduction : remplacer « jour » ou
       « heure » isolement irait casser des dizaines d'autres phrases du moteur. */
    var PRESTA_U_TXT = 'Pauschale|Stunde|Tag|Einheit';
    var PRESTA_UNITES = (function(){
      var m = PRESTA_U_TXT.split('|');
      return {forfait:m[0], heure:m[1], jour:m[2], unite:m[3]};
    })();
    /* 15/10/2026, Charles : « il faut que le port s'affiche exactement comme aujourd'hui,
       mais si nous on veut le modifier en tant que vendeur, pouvoir le faire ». Le champ
       est donc VIDE par defaut et le bareme s'applique comme avant ; rempli, il remplace
       le prix et RIEN d'autre : le libelle vu par le client ne bouge pas d'un mot. */
    var PORT_PLAFOND = 1000000;   /* 10 000 EUR HT, meme role que le plafond de prestation */
    var PORT_LIBELLES = 'Vorgegebene Versandkosten (€ netto)|Leer: Gewichtstabelle|Vorgegeben:|statt der Tabelle';
    var ARCHIVES_LIBELLES = 'Archivierte anzeigen|Archivierte ausblenden';
    var PRESTA_LIBELLES = 'Freie Position|Bezeichnung, auf dem Angebot sichtbar|Menge|Einzelpreis netto|Hinzugefügt:|Ergänzen Sie Bezeichnung, Menge und Einzelpreis.|neue Summe|Freie Position hinzufügen|Diese Position entfernen';
    /* Memes bornes que nettoyerPresta du worker, pour la meme raison que le port ci-dessus :
       le chemin base64 ne voit jamais le serveur. */
    /* Pose par le Comptoir. Chez un client, le volet n'existe pas : elle ne fait rien. */
    var prestaDeplier=function(){};
    function nettoyerPrestaLocal(p){
      if(!p || typeof p!=='object') return null;
      var lib=String(p.lib||'').replace(/<[^>]*>/g,'').replace(/\s+/g,' ').trim().slice(0,120);
      var q=Math.round(Number(p.qte)*100)/100, pu=Math.round(Number(p.puCents));
      if(!lib || !isFinite(q) || q<=0 || q>1000) return null;
      if(!isFinite(pu) || pu<0 || pu>PRESTA_PLAFOND) return null;
      if(Math.round(q*pu) > PRESTA_PLAFOND) return null;
      var u=['forfait','heure','jour','unite'].indexOf(String(p.unite||''))!==-1?String(p.unite):'forfait';
      return {lib:lib, qte:q, unite:u, puCents:pu};
    }
    function prestaTotalCents(){
      if(!presta) return 0;
      return Math.round(presta.qte * presta.puCents);
    }
    function prestaDetail(){
      if(!presta || presta.unite === 'forfait') return '';
      var u = PRESTA_UNITES[presta.unite] || presta.unite;
      if(presta.qte > 1) u += 's';
      var q = presta.qte.toLocaleString('fr-FR');
      return q + ' ' + u + ' × ' + euro(presta.puCents);
    }
    /* 15/10/2026. Le volet du devis se construit en chaine et finit dans innerHTML.
       Trois valeurs y sont du TEXTE LIBRE : le motif du geste commercial, le code
       partenaire et le libelle de la prestation. Le serveur retire bien les balises a
       l'enregistrement, mais un devis peut aussi arriver en base64 dans l'adresse
       (« ?devis=... » et la reference collee), et CE chemin ne passe jamais par le
       serveur. Un libelle contenant <img src=x onerror=...> s'executait donc sur le
       domaine de la boutique. On echappe au moment d'ecrire : c'est le seul endroit qui
       protege les deux chemins a la fois. */
    function echappe(t){
      return String(t==null?'':t).replace(/[&<>"']/g,function(c){
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; });
    }
    function prestaLigne(){
      if(!presta) return '';
      var d = prestaDetail();
      return presta.lib + (d ? ' (' + d + ')' : '');
    }
    var portOffert = false; var portManuel = null; /* centimes HT, null = bareme */ var acompte = 0; var noteInterne = ''; var notePendante = null; var motClient = ''; /* pourcentage, pose par un associe */ /* livraison offerte par un associe, meme regle que le geste */
    var shipMode = 'livraison';
    var client = { soc:'', nom:'', em:'', tel:'', adr:'', adr2:'', cp:'', ville:'',
                   tva:'', pays:'FR' };
    /* Livraison. « meme » vrai signifie « livrer a l'adresse de facturation ». */
    var livr = { meme:true, nom:'', contact:'', tel:'', adr:'', adr2:'', cp:'', ville:'', pays:'FR' };
    var CH_F = ['soc','nom','em','tel','adr','adr2','cp','ville','tva'];
    var CH_L = ['nom','contact','tel','adr','adr2','cp','ville'];
    var curDevis = null; /* {num, now, editUrl} du devis courant, invalidé dès que l'estimation change */
    /* 22/09/2026. Vrai quand le devis a ete ouvert AVEC SON JETON : c'est le devis de ce
       lecteur, qui le garde sous son numero, exactement comme au Comptoir. */
    var devisRepris = false;
    /* 22/09/2026. Le devis repris a change depuis sa derniere sauvegarde : le prochain PDF,
       envoi ou accord le reecrit d'abord, sous son numero et avec son jeton. */
    var devisModifie = false;
    var majCarteDevis = function(){}; /* remplace par le mode devis s'il est actif */
    var state = { lines: [], pub: 0, pro: 0, ignifCount: 0, ignifTotal: 0, palettes: 0, ship: 0, codeRemise: 0, prestaTotal: 0, presta: null, total: 0, plantCount: 0, items: 0 };

    function euro(c){ return (c/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'}); }
    /* Deux faits qui vivent au meme endroit que le reste du site. */
    /* Posees par la page, qui seule sait lire les metachamps de la boutique. */
    var CFG = window.HOPER_CFG || {};
    /* 17/09/2026. Preuve du vendeur : imprimee par Shopify pour les deux associes seulement,
       verifiee par le worker. Sans elle, le Comptoir n'ouvre rien de plus que le catalogue. */
    var VENDEUR = (CFG.vendeur && CFG.vendeur.jeton) ? CFG.vendeur : null;
    var EXPEDITION = CFG.expedition || 'courant octobre 2026';
    /* 17/09/2026 (repasse) : les dates viennent de metachamps francais ; en anglais on
       traduit le mois et le qualificatif (« courant octobre 2026 » -> « in October 2026 »). */
    function dateLangue(t){
      t=String(t||'');
      if((document.documentElement.lang||'').toLowerCase().indexOf('en')!==0) return t;
      var M=[['janvier','January'],['f\u00e9vrier','February'],['mars','March'],['avril','April'],['mai','May'],['juin','June'],['juillet','July'],['ao\u00fbt','August'],['septembre','September'],['octobre','October'],['novembre','November'],['d\u00e9cembre','December']];
      t=t.replace(/^courant /,'in ').replace(/^d\u00e9but /,'early ').replace(/^fin /,'late ').replace(/^mi-/,'mid-');
      M.forEach(function(m){ t=t.replace(m[0],m[1]); });
      return t;
    }
    function validiteTexte(){
      /* 01/10/2026. Le devis vaut 14 jours, point. La seconde echeance (« et au plus tard
         jusqu'au terme du tarif de lancement ») est tombee avec le tarif de lancement, et
         le repli « 30 septembre 2026 » ecrit ici ressortait des que le metachamp etait vide. */
      return 'Gueltig 14 Tage';
    }
    function euroPdf(c){ var v=(c/100).toFixed(2).split('.'); return v[0].replace(/\B(?=(\d{3})+(?!\d))/g,' ')+','+v[1]+' EUR'; }
    function pdfTxt(s){ return String(s||'').replace(/\u2022/g,'\u00b7').replace(/\u2300|\u00d8|\u2205/g,'').replace(/[^\x00-\xFF]/g,'').replace(/\s+/g,' ').trim(); }
    function htOf(ttc){ return Math.round(ttc/(1+VAT)); }
    function heightOfLabel(label){ var m=(label||'').match(/(\d{2,3})\s*cm/i); return m?parseInt(m[1],10):null; }
    function ignifUnitFor(label){
      var h=heightOfLabel(label);
      if(h===null) return IGNIF.mid;
      if(h<=120) return IGNIF.small;
      if(h<=180) return IGNIF.mid;
      return IGNIF.tall;
    }
    function selOpt(card){ var s=card.querySelector('.hcat-size'); return s.options[s.selectedIndex]; }
    /* data-pub porte le prix TTC RENDU par Shopify : le tarif professionnel pour
       un compte ouvert, le prix public pour tout le monde d'autre. Les deux prix
       se deduisent ici, au meme endroit, pour ne jamais arrondir deux fois.

       12/09/2026 : la remise B2B est une regle unique de -15 % sur tout le
       catalogue, sans une seule exception saisie a la main. Math.round(ttc*0.85)
       a ete compare au prix reellement facture par Shopify sur les 63 variantes,
       une par une via contextualPricing : zero ecart, y compris sur les douze
       cache-pots qui tombent pile sur un demi-centime (22,50 donne 19,13, pas
       19,12). Le prix montre a un visiteur anonyme est donc le vrai, pas une
       estimation. */
    /* Remonter du prix pro au prix public ne peut pas se faire par une simple
       division : 13,50 donne 11,48 en pro, et 11,48 / 0,85 rend 13,51. Le banc
       l'a attrape sur les quatre cache-pots qui tombent sur un demi-centime, ou
       un visiteur anonyme lisait « public 11,25 » et le meme visiteur connecte
       « public 11,26 ». On cherche donc le plus petit prix public qui redonne
       exactement ce prix pro : c'est celui que le commercant a saisi. */
    function publicDepuisPro(ttcPro){
      var p = Math.round(ttcPro/REMISE_PRO);
      while(p > 1 && Math.round((p-1)*REMISE_PRO) === ttcPro) p--;
      return p;
    }
    function prixDe(ttc){
      ttc = parseInt(ttc,10)||0;
      var ttcPro = PRO ? ttc : Math.round(ttc*REMISE_PRO);
      var ttcPub = PRO ? publicDepuisPro(ttc) : ttc;
      return { pro: htOf(ttcPro), pub: htOf(ttcPub), ttcPub: ttcPub };
    }
    function proOfSingle(card){ return prixDe(card.getAttribute('data-pub')).pro; }
    function proOfMulti(card){ return prixDe(selOpt(card).getAttribute('data-pub')).pro; }

    function paint(card){
      var p = card.getAttribute('data-kind')==='multi'
        ? prixDe(selOpt(card).getAttribute('data-pub'))
        : prixDe(card.getAttribute('data-pub'));
      card.querySelector('.hcat-pub-val').textContent=euro(p.pub);
      card.querySelector('.hcat-pro-val').textContent=euro(p.pro);
    }
    function swapImg(card){
      var img=card.querySelector('.hcat-imgwrap img'); if(!img) return;
      var url=selOpt(card).getAttribute('data-vimg'); if(!url || img.getAttribute('src')===url) return;
      var tmp=new Image(); img.style.opacity='0.3';
      tmp.onload=function(){img.src=url;img.style.opacity='';}; tmp.onerror=function(){img.style.opacity='';}; tmp.src=url;
    }
    function multiSummary(card){
      var parts=[]; var q=card._qty||{};
      var s=card.querySelector('.hcat-size');
      Array.prototype.forEach.call(s.options,function(o){ var n=q[o.value]||0; if(n>0) parts.push(o.text+' ×'+n); });
      card.querySelector('.hcat-multi-summary').textContent = parts.join(' · ');
    }

    function recalc(){
      var items=0, tp=0, tr=0, tpTtc=0, lines=[], plantCount=0, ignifCount=0, ignifTotal=0;
      var ignifOn = ignifMain && ignifMain.checked && ignifPossible();
      cards.forEach(function(card){
        var isPlante = card.getAttribute('data-plante')==='1';
        if(card.getAttribute('data-kind')==='multi'){
          var q=card._qty||{}; var s=card.querySelector('.hcat-size');
          Array.prototype.forEach.call(s.options,function(o){
            var qty=q[o.value]||0; if(qty<=0) return;
            var pp=prixDe(o.getAttribute('data-pub')), pro=pp.pro, pub=pp.pub;
            items+=qty; tp+=qty*pub; tr+=qty*pro; tpTtc+=qty*pp.ttcPub;
            lines.push({name:card.getAttribute('data-name'),size:o.text,qty:qty,proUnit:pro,total:qty*pro});
          });
        } else {
          var qi=card.querySelector('.hcat-qty'); var qty=parseInt(qi.value,10)||0;
          if(qty<0){qty=0;qi.value=0;}
          if(qty===0) return;
          var pp=prixDe(card.getAttribute('data-pub')), pro=pp.pro, pub=pp.pub;
          items+=qty; tp+=qty*pub; tr+=qty*pro; tpTtc+=qty*pp.ttcPub;
          var size=card.getAttribute('data-size')||'';
          if(isPlante){
            plantCount+=qty;
            if(ignifOn){ ignifCount+=qty; ignifTotal+=qty*ignifUnitFor(size); }
          }
          lines.push({name:card.getAttribute('data-name'),size:size,qty:qty,proUnit:pro,total:qty*pro});
        }
      });
      /* Le port et le nombre de palettes sont calcules par le SERVEUR, au poids
         reel et au pays reel, exactement comme la facture. Tant qu'il n'a pas
         repondu, aucun montant n'est affiche : mieux vaut « calculee a la
         validation » qu'un chiffre qui ne sera pas celui de la facture. */
      var palettes = 0, ship = 0, portSur = false;
      if(shipMode!=='retrait' && items>0){
        var sigPort = signaturePort();
        if(portServeur.sig === sigPort){
          if(portServeur.ht !== null){
            ship = portServeur.ht; palettes = portServeur.palettes||0; portSur = true;
          }
        } else { demanderPort(sigPort); }
        /* Le prix impose passe APRES le bareme : il le remplace, y compris quand le
           bareme n'a pas su repondre. C'est ce qui permet de chiffrer une destination
           hors grille au lieu de bloquer le devis. Les palettes restent comptees : elles
           disent a l'entrepot comment preparer, pas combien facturer. */
        if(portManuel !== null){ ship = portManuel; portSur = true; }
      }
      if(portOffert && items>0){ ship=0; palettes=0; portSur=true; }
      var codeRemise = 0;
      if(geste){
        codeRemise = geste.t==='pct' ? Math.round(tr*geste.v/100) : Math.min(Math.round(geste.v*100), tr);
      } else if(appliedCode){
        codeRemise = appliedCode.pct ? Math.round(tr*appliedCode.pct/100) : Math.min(Math.round((appliedCode.amountCents||0)/(1+VAT)), tr);
      }
      var prestaTotal = prestaTotalCents();
      var total = tr - codeRemise + ignifTotal + ship + prestaTotal;
      state={lines:lines,pub:tp,pubTtc:tpTtc,pro:tr,ignifCount:ignifCount,ignifTotal:ignifTotal,palettes:palettes,ship:ship,portSur:portSur,codeRemise:codeRemise,prestaTotal:prestaTotal,presta:presta,total:total,plantCount:plantCount,items:items};
      if(items>0){
        bar.classList.add('is-active');
        bar.querySelector('.hcat-bar-count').textContent=items+(items>1?' Stücke':' Stück');
        bar.querySelector('.hcat-bar-pub').textContent=euro(tp);
        /* 17/09/2026. La barre annoncait « 125,83 EUR pour votre devis, soit 20,76 EUR
           d'economie » alors que la marchandise faisait 117,58 EUR : la livraison estimee
           s'ajoutait en silence, et l'economie etait calculee sans elle. Deux montants
           differents pour une meme selection. La marchandise et la livraison sont donc
           affichees separement. */
        bar.querySelector('.hcat-bar-pro').textContent=euro(total-ship);
        var lignePort=bar.querySelector('.hcat-bar-portline');
        if(lignePort){
          if(ship>0){ bar.querySelector('.hcat-bar-port').textContent=euro(ship); lignePort.style.display=''; }
          else { lignePort.style.display='none'; }
        }
        bar.querySelector('.hcat-bar-save').textContent=euro(tp-tr+codeRemise);
      } else { bar.classList.remove('is-active'); }
      if(modal.classList.contains('is-open')) renderModal();
      /* 17/09/2026, Comptoir tranche 2. Pour un visiteur ordinaire, le numero DOIT
         disparaitre des que l'estimation change : afficher un numero qui ne correspond
         plus a ce qu'il a sous les yeux serait pire que ne rien afficher.
         En mode Comptoir c'est l'inverse qu'il faut. Le vendeur reprend le devis de son
         client, ajoute une piece, change une quantite : s'il repart sur un numero neuf a
         chaque geste, il fabrique deux devis pour une seule discussion et la reprise ne
         sert a rien. Le numero reste donc, et c'est le CONTENU qui suivra, la porte
         d'ecriture du 16/09 autorisant la reecriture avec le jeton.
         Le bouton « Repartir de zero » efface, lui, en toutes circonstances : sinon il
         mentirait sur ce qu'il fait. */
      /* 22/09/2026 : meme regle pour le client qui a ouvert SON devis avec son jeton. S'il
         repartait sur un numero neuf, le serveur effacait le geste commercial, la
         livraison offerte, l'acompte, la garantie et l'accord, qui ne suivent que le
         numero. Il payait donc plein tarif un devis affiche remise. L'accord, lui, tombe
         de lui-meme cote serveur des que le contenu change. */
      var cptActif=!!(curDevis && ((window.HOPER_CFG && window.HOPER_CFG.comptoir) || devisRepris));
      if(!cptActif){
        curDevis=null;
        var aft=document.getElementById('hcat-m-afternum'); if(aft) aft.classList.remove('is-on');
        var conf=document.getElementById('hcat-m-confirm'); if(conf) conf.classList.remove('is-on');
      } else devisModifie=true;
      majCarteDevis();
      persist();
    }

    /* --- persistance + lien d'estimation --- */
    /* --- vrai tarif de port, demande au serveur --- */
    var portServeur = { sig: null, ht: null, kg: null, palettes: 0, sur: false };
    var portEnCours = null;
    /* 08/09/2026, trouve par l'audit. Le pays etait DEVINE en cherchant un nom de
       pays dans l'adresse libre : « 5 avenue d'Italie, 75013 Paris » partait en
       Italie au tarif italien, « Hotel Le Portugal, 75015 Paris » au Portugal, et
       une adresse suisse ecrite sans le mot Suisse partait en France, 58 EUR de
       port en moins que la realite. Pire, ce pays devine neutralisait la detection
       du serveur, qui ne lit l'adresse que si le navigateur ne dit rien.
       Le pays fixe le port ET le pays de la commande : il se CHOISIT. */
    function paysLivraison(){
      /* Le port et le regime de TVA suivent le pays ou part la marchandise, pas
         celui du siege qui recoit la facture. */
      var id = (livr.meme ? 'hcat-cl-pays' : 'hcat-lv-pays');
      var el = document.getElementById(id);
      var v = (el && el.value ? el.value : (livr.meme ? client.pays : livr.pays) || 'FR').toUpperCase();
      return /^[A-Z]{2}$/.test(v) ? v : 'FR';
    }
    function quantites(){
      var q={};
      cards.forEach(function(card){
        if(card.getAttribute('data-kind')==='multi'){
          var m=card._qty||{}; for(var k in m){ if(m[k]>0) q[k]=m[k]; }
        } else {
          var v=parseInt(card.querySelector('.hcat-qty').value,10)||0;
          if(v>0) q[card.getAttribute('data-vid')]=v;
        }
      });
      return q;
    }
    function signaturePort(){
      var q=quantites(), k=Object.keys(q).sort().map(function(x){return x+':'+q[x];}).join(',');
      return k+'|'+paysLivraison();
    }
    function demanderPort(sig){
      if(portEnCours === sig) return;
      portEnCours = sig;
      var q = quantites();
      if(!Object.keys(q).length){ portEnCours=null; return; }
      fetch(CODE_API.replace('/pro/code','/pro/port'), { method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ q:q, pays:paysLivraison() }) })
        .then(function(r){ return r.json(); })
        .then(function(d){
          portEnCours=null;
          if(d && d.ok){ portServeur={sig:sig, ht:d.ht_cents, kg:d.kg, palettes:d.palettes||0, sur:true}; }
          else { portServeur={sig:sig, ht:null, kg:null, palettes:0, sur:false}; }
          recalc();
          /* La confirmation du port impose compare au bareme : elle ne peut etre juste
             qu'une fois le bareme revenu. Garde de type : demanderPort peut en theorie
             partir avant que le Comptoir soit construit, et le client n'a pas ce champ. */
          if(typeof majPortOk==='function') majPortOk();
        })
        .catch(function(){ portEnCours=null; portServeur={sig:sig, ht:null, kg:null, palettes:0, sur:false}; recalc(); });
    }

    /* 15/10/2026. LA REGLE DU COMPTOIR : un champ VIDE retire la valeur, une saisie
       IMPOSSIBLE la laisse en place. Elle se tient ICI et pas seulement au serveur, parce
       que le serveur ne voit jamais la saisie absurde : il ne voit que ce que cet ecran
       lui envoie. Renvoyer null sur un zero en trop effacait en silence le port que le
       vendeur croyait pose, et la commande repartait au bareme.
       null  = retire · undefined = ne touche a rien (JSON supprime la cle) */
    function portAEnvoyer(){
      if(portManuel!==null) return portManuel;
      var i=document.getElementById('hcat-cpt-ps');
      return (!i || String(i.value||'').trim()==='') ? null : undefined;
    }
    function prestaAEnvoyer(){
      if(presta) return presta;
      var vide=['hcat-cpt-pr-lib','hcat-cpt-pr-qte','hcat-cpt-pr-pu'].every(function(id){
        var e=document.getElementById(id); return !e || String(e.value||'').trim()===''; });
      return vide ? null : undefined;
    }
    function collectState(){
      var q={};
      cards.forEach(function(card){
        if(card.getAttribute('data-kind')==='multi'){
          var m=card._qty||{}; for(var k in m){ if(m[k]>0) q[k]=m[k]; }
        } else {
          var v=parseInt(card.querySelector('.hcat-qty').value,10)||0;
          if(v>0) q[card.getAttribute('data-vid')]=v;
        }
      });
      return { q:q, ig:(ignifMain&&ignifMain.checked)?1:0, sm:shipMode, lo:((document.getElementById('hcat-soc-choix')||{}).value||undefined), code:appliedCode?appliedCode.code:'', gc:VENDEUR?(geste||null):undefined, po:VENDEUR?portOffert:undefined, ps:VENDEUR?portAEnvoyer():undefined, ac:VENDEUR?acompte:undefined, nt:VENDEUR?noteInterne:undefined, pr:VENDEUR?prestaAEnvoyer():undefined,
               lv:{ meme:livr.meme, nom:livr.nom, contact:livr.contact, tel:livr.tel, adr:livr.adr, adr2:livr.adr2, cp:livr.cp, ville:livr.ville, pays:livr.pays },
               cl:{ soc:client.soc, nom:client.nom, em:client.em, tel:client.tel,
                    adr:[client.adr,client.adr2].filter(Boolean).join(', '),
                    tva:client.tva, pays:client.pays||'FR' },
               fact:{ soc:client.soc, nom:client.nom, tel:client.tel, rue:client.adr,
                      comp:client.adr2, cp:client.cp, ville:client.ville, pays:client.pays||'FR' },
               livraison: livr.meme
                 ? { nom:client.soc, contact:client.nom, tel:client.tel, rue:client.adr,
                     comp:client.adr2, cp:client.cp, ville:client.ville, pays:client.pays||'FR' }
                 : { nom:livr.nom||client.soc, contact:livr.contact||client.nom,
                     tel:livr.tel||client.tel, rue:livr.adr, comp:livr.adr2,
                     cp:livr.cp, ville:livr.ville, pays:livr.pays||'FR' },
               lines: state.lines.map(function(l){ return {n:l.name, s:l.size, q:l.qty, u:l.proUnit}; }),
               totals: {pro:state.pro, ignifCount:state.ignifCount, ignifTotal:state.ignifTotal,
                        palettes:state.palettes, ship:state.ship, codeRemise:state.codeRemise, total:state.total} };
    }
    function persist(){ try{ localStorage.setItem('hcat:v1', JSON.stringify(collectState())); }catch(e){} }
    function restoreState(st){
      if(!st || !st.q) return;
      setTimeout(function(){ majBandeauVendeur(); },0);
      /* La note interne ne descend jamais avec le devis : elle arrive par la liste vendeur. */
      noteInterne = (notePendante !== null) ? notePendante : (st._nt || '');
      notePendante = null;
      (function(){ var n=document.getElementById('hcat-cpt-nt'); if(n) n.value=noteInterne; })();
      acompte = Number(st._ac)>0 ? Number(st._ac) : 0; (function(){ var a=document.getElementById('hcat-cpt-ac'); if(a) a.value=acompte||''; })();
      portOffert = st._po===true; (function(){ var c=document.getElementById('hcat-cpt-po'); if(c) c.checked=portOffert; })();
      /* Le port impose voyage SANS tiret bas, comme la prestation : le client doit voir
         le meme montant que le vendeur. Seule son ECRITURE est reservee au Comptoir. */
      /* Memes bornes que le serveur. L'etat peut venir d'un base64 entierement choisi par
         le visiteur, qui ne passe par aucun controle : sans ces bornes, un lien fabrique
         affichait et imprimait un devis a l'en-tete HOPER avec un port negatif. */
      portManuel = (typeof st.ps === 'number' && isFinite(st.ps)
                    && st.ps >= 0 && st.ps <= PORT_PLAFOND) ? Math.round(st.ps) : null;
      (function(){ var c=document.getElementById('hcat-cpt-ps');
        if(c) c.value = portManuel===null ? '' : (portManuel/100).toFixed(2); })();
      /* Le worker ne prefixe en « _ » que les champs vendeur qu'il connait (gc, po, ac, nt).
         « pr » lui est inconnu, il le traverse tel quel : on relit donc st.pr.
         Et on la repose POUR TOUT LE MONDE, pas seulement pour le vendeur : un client qui
         rouvre son devis doit retrouver le meme total que sur le PDF qu'il a recu. Seuls
         les CHAMPS de saisie restent au Comptoir, parce qu'ils n'existent pas chez lui. */
      presta = nettoyerPrestaLocal(st.pr);
      (function(){
        var l=document.getElementById('hcat-cpt-pr-lib'), q=document.getElementById('hcat-cpt-pr-qte'),
            u=document.getElementById('hcat-cpt-pr-u'),   v=document.getElementById('hcat-cpt-pr-pu');
        if(l) l.value = presta ? presta.lib : '';
        if(q) q.value = presta ? presta.qte : '';
        if(u) u.value = presta ? presta.unite : 'forfait';
        if(v) v.value = presta ? (presta.puCents/100) : '';
        prestaDeplier(!!presta);
      })();
      geste = (st._gc && st._gc.v>0) ? {t:st._gc.t, v:st._gc.v, m:st._gc.m||''} : null;
      (function(){ var v=document.getElementById('hcat-cpt-gc-v'), t=document.getElementById('hcat-cpt-gc-t'), m=document.getElementById('hcat-cpt-gc-m');
        if(v){ v.value=geste?geste.v:''; } if(t && geste){ t.value=geste.t; } if(m){ m.value=geste?geste.m:''; } })();
      cards.forEach(function(card){
        if(card.getAttribute('data-kind')==='multi'){
          var s2=card.querySelector('.hcat-size'); var any=false;
          Array.prototype.forEach.call(s2.options,function(o){ var n=st.q[o.value]; if(n>0){ card._qty[o.value]=n; any=true; } });
          if(any){ multiSummary(card); card.querySelector('.hcat-qty').value=card._qty[s2.value]||0; }
        } else {
          var n=st.q[card.getAttribute('data-vid')];
          if(n>0) card.querySelector('.hcat-qty').value=n;
        }
      });
      if(st.ig){ if(ignifMain) ignifMain.checked=true; if(ignifModal) ignifModal.checked=true; }
      if(st.sm){ shipMode=st.sm; Array.prototype.forEach.call(document.querySelectorAll('input[name="hcat-ship"],input[name="hcat-ship-m"]'),function(r){ r.checked=(r.value===st.sm); }); }
      if(st.cl){
        CH_F.forEach(function(k){ client[k]=st.cl[k]||''; });
        client.pays=st.cl.pays||'FR';
      }
      /* 22/09/2026, reproduit en ligne : a la reouverture d'un devis, le code postal et la
         ville du client disparaissaient. Le bloc « cl » ne les porte pas (il joint rue et
         complement en une ligne) ; c'est « fact » qui porte l'adresse en champs separes.
         Consequence : toute proforma d'un devis rouvert, au Comptoir comme chez le client,
         etait refusee faute d'adresse. On relit donc l'adresse de facturation dans « fact ». */
      if(st.fact){
        var f=st.fact;
        if(f.rue!==undefined){ client.adr=f.rue||''; client.adr2=f.comp||''; }
        if(f.cp!==undefined) client.cp=f.cp||'';
        if(f.ville!==undefined) client.ville=f.ville||'';
        if(f.pays) client.pays=f.pays;
      }
      if(st.lv){
        CH_L.forEach(function(k){ livr[k]=st.lv[k]||''; });
        livr.pays=st.lv.pays||'FR'; livr.meme=(st.lv.meme!==false);
      }
      if(st.cl||st.lv) fillClientFields();
      majIgnifPays();
      recalc();
      if(st.code){
        fetch(CODE_API+'?code='+encodeURIComponent(st.code)).then(function(r){return r.json();}).then(function(d){
          if(d && d.valid){
            appliedCode = d.type==='pct' ? {code:d.code,pct:d.pct} : {code:d.code,amountCents:d.amountCents};
            var i1=document.getElementById('hcat-code'), i2=document.getElementById('hcat-code-m');
            if(i1) i1.value=d.code; if(i2) i2.value=d.code;
          }
          recalc();
        }).catch(function(){});
      }
    }
    function fillClientFields(){
      CH_F.forEach(function(k){
        var el=document.getElementById('hcat-cl-'+k);
        if(el && el.value!==client[k]) el.value=client[k]||'';
      });
      var fp=document.getElementById('hcat-cl-pays');
      if(fp && fp.value!==client.pays) fp.value=client.pays||'FR';
      CH_L.forEach(function(k){
        var el=document.getElementById('hcat-lv-'+k);
        if(el && el.value!==livr[k]) el.value=livr[k]||'';
      });
      var lp=document.getElementById('hcat-lv-pays');
      if(lp && lp.value!==livr.pays) lp.value=livr.pays||'FR';
      var me=document.getElementById('hcat-lv-meme');
      if(me) me.checked=!!livr.meme;
      var bl=document.getElementById('hcat-lv-bloc');
      if(bl) bl.style.display = livr.meme ? 'none' : '';
    }
    CH_F.forEach(function(k){
      var el=document.getElementById('hcat-cl-'+k);
      if(el) el.addEventListener('input',function(){ client[k]=el.value; persist(); });
    });
    /* 17/09/2026. Fiche client par l'annuaire public des entreprises : le nom ou le SIRET
       suffit, l'adresse du siege et la TVA se remplissent. Le worker ne rend que la raison
       sociale legale d'une entreprise active. */
    function brancherAnnuaire(soc, boite, surChoix){
      if(!soc || !boite) return;
      var minuterie=null, derniere='';
      soc.addEventListener('input',function(){
        var q=(soc.value||'').trim();
        clearTimeout(minuterie);
        if(q.length<3 || q===derniere){ if(q.length<3) boite.hidden=true; return; }
        minuterie=setTimeout(function(){
          derniere=q;
          fetch(ANNUAIRE_API+'?per_page=6&q='+encodeURIComponent(q)).then(function(r){ return r.json(); }).then(function(d){
            if((soc.value||'').trim()!==q) return;
            var res=((d && d.results)||[]).map(ficheAnnuaire).filter(Boolean).slice(0,5);
            boite.innerHTML='';
            if(!res.length){ boite.hidden=true; return; }
            var aide=document.createElement('p'); aide.className='hcat-suggest-aide'; aide.textContent=boite.getAttribute('data-aide'); boite.appendChild(aide);
            res.forEach(function(e){
              var bt=document.createElement('button'); bt.type='button'; bt.className='hcat-suggest-l';
              var n=document.createElement('b'); n.textContent=e.nom; bt.appendChild(n);
              var sp=document.createElement('span'); sp.textContent=[e.cp, e.ville, 'SIREN '+e.siren].filter(Boolean).join(' · '); bt.appendChild(sp);
              bt.addEventListener('click',function(){ derniere=e.nom; surChoix(e); boite.hidden=true; });
              boite.appendChild(bt);
            });
            boite.hidden=false;
          }).catch(function(){ boite.hidden=true; });
        },350);
      });
      document.addEventListener('click',function(ev){ if(!boite.contains(ev.target) && ev.target!==soc) boite.hidden=true; });
    }
    function poserChamp(id,val){ var el=document.getElementById(id); if(el && val!==undefined && val!==null){ el.value=val; el.dispatchEvent(new Event('input',{bubbles:true})); el.dispatchEvent(new Event('change',{bubbles:true})); } }
    function choisirPaysFR(){ var p=document.getElementById('hcat-cl-pays'); if(p && p.value!=='FR'){ p.value='FR'; p.dispatchEvent(new Event('change',{bubbles:true})); } }
    brancherAnnuaire(document.getElementById('hcat-cl-soc'), document.getElementById('hcat-cl-suggest'), function(e){
      poserChamp('hcat-cl-soc',e.nom); poserChamp('hcat-cl-adr',e.adresse); poserChamp('hcat-cl-cp',e.cp);
      poserChamp('hcat-cl-ville',e.ville); poserChamp('hcat-cl-tva',e.tva); choisirPaysFR();
    });
    CH_L.forEach(function(k){
      var el=document.getElementById('hcat-lv-'+k);
      if(el) el.addEventListener('input',function(){ livr[k]=el.value; persist(); });
    });
    (function(){
      var me=document.getElementById('hcat-lv-meme');
      if(me) me.addEventListener('change',function(){
        livr.meme=me.checked;
        var bl=document.getElementById('hcat-lv-bloc');
        if(bl) bl.style.display = livr.meme ? 'none' : '';
        persist(); majIgnifPays(); portServeur={sig:null,ht:null,kg:null,palettes:0,sur:false}; recalc();
      });
      var lp=document.getElementById('hcat-lv-pays');
      if(lp) lp.addEventListener('change',function(){
        livr.pays=lp.value; persist(); majIgnifPays();
        portServeur={sig:null,ht:null,kg:null,palettes:0,sur:false}; recalc();
      });
    })();
    /* Changer de pays change le port ET le regime de TVA : on recalcule. Sinon
       l'ecran garde le tarif du pays precedent, jusque dans le PDF. */
    (function(){
      var p=document.getElementById('hcat-cl-pays');
      if(p) p.addEventListener('change',function(){
        client.pays=p.value; persist(); majIgnifPays();
        portServeur={sig:null,ht:null,kg:null,palettes:0,sur:false};
        recalc();
      });
    })();

    /* Regime de TVA. Le tunnel annoncait 20 % a tout le monde, y compris a un client
       europeen muni d'un numero intracommunautaire valide a qui l'autoliquidation
       avait ete promise par ecrit. La decision se prend sur le serveur, qui verifie
       le numero aupres de VIES : le navigateur ne fait qu'afficher le resultat. */
    var tvaRegime = { exonere:false, motif:'', pays:'' };
    /* L'exoneration exige que la marchandise PARTE dans le pays du numero. Le
       serveur applique deja cette regle : l'ecran doit dire la meme chose, sinon il
       promet un total hors taxes qui deviendra un total TTC au paiement. */
    /* Liste identique a celle du serveur. Une livraison hors Union europeenne est
       une EXPORTATION : exoneree, quel que soit le numero de TVA du client. Le
       serveur l applique deja ; l ecran et le PDF annonçaient encore 20 % a un
       hotel de Londres, soit 2 000 EUR de trop sur un devis de 10 000. 09/09/2026. */
    var UE = ['AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR','HU',
              'IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK'];
    /* 17/09/2026 : Monaco est dans le territoire fiscal francais, jamais un export. */
    function horsUE(){ var p=paysLivraison(); return p !== 'MC' && UE.indexOf(p) === -1; }
    function exonereReel(){
      if(horsUE()) return true;
      return !!(tvaRegime.exonere && tvaRegime.pays && tvaRegime.pays === paysLivraison());
    }
    function majTva(){
      var t=(client.tva||'').trim();
      if(t.length<6){ tvaRegime={exonere:false,motif:'',pays:''}; recalc(); return; }
      fetch(CODE_API.replace('/pro/code','/pro/tva')+'?tva='+encodeURIComponent(t))
        .then(function(r){ return r.json(); })
        .then(function(d){ tvaRegime={exonere:!!(d&&d.exonere),motif:(d&&d.motif)||'',pays:(d&&d.pays)||''}; recalc(); })
        .catch(function(){ tvaRegime={exonere:false,motif:'',pays:''}; recalc(); });
    }
    (function(){
      var el=document.getElementById('hcat-cl-tva');
      if(el){ el.addEventListener('change',majTva); el.addEventListener('blur',majTva); }
    })();

    /* --- panneau « Votre societe », 17/09/2026 --------------------------------------
       Le numero de TVA pose sur la commande venait du champ que le client TAPE. Or un
       groupe comme GROUPE IMMOVATION porte 23 etablissements et 23 numeros distincts :
       un devis pouvait partir avec le numero d'un autre etablissement, donc une facture
       a refaire et une mention d'autoliquidation potentiellement fausse.

       Choisir un etablissement remplit desormais la societe, le numero, l'adresse de
       facturation, le code postal, la ville et le pays d'un seul geste, et rend le
       numero non modifiable. Shopify ne propose que les etablissements ou ce contact a
       un role : la liste est juste par construction.

       REPLI : sans panneau, rien ne change. La saisie libre reste active exactement
       comme avant, et le parcours d'un client sans societe est inchange. */
    (function(){
      var choix=document.getElementById('hcat-soc-choix');
      if(!choix) return;
      var sortie=document.getElementById('hcat-soc-tva');
      var champTva=document.getElementById('hcat-cl-tva');
      function appliquer(){
        var o=choix.options[choix.selectedIndex];
        if(!o) return;
        var d=o.dataset||{};
        var avant=client.tva;
        if(d.nom)   client.soc=d.nom;
        if(d.tva)   client.tva=d.tva;
        if(d.adr)   client.adr=d.adr;
        if(d.adr2!==undefined) client.adr2=d.adr2||'';
        if(d.cp)    client.cp=d.cp;
        if(d.ville) client.ville=d.ville;
        if(d.pays)  client.pays=d.pays;
        fillClientFields();
        /* Le numero vient de Shopify : le laisser modifiable ramenerait exactement le
           defaut qu'on ferme. On le verrouille, sans le cacher : le client doit voir
           ce qui figurera sur sa facture. */
        if(champTva && d.tva){ champTva.readOnly=true; champTva.setAttribute('aria-readonly','true'); }
        if(sortie){
          sortie.textContent = d.tva
            ? ((document.documentElement.lang||'').toLowerCase().indexOf('en')===0
                ? 'Registration number carried to the invoice: ' + d.tva
                : 'Auf der Rechnung übernommene Nummer: ' + d.tva)
            : '';
        }
        persist();
        if(client.tva && client.tva!==avant) majTva();
      }
      choix.addEventListener('change',appliquer);
      appliquer();
    })();

    /* --- remise à zéro (avant reprise d'un devis) --- */
    /* Libelle de la remise en plus du tarif pro : geste commercial ou code partenaire. */
    function libelleRemise(pdf){
      if(geste){
        var lib=(document.getElementById('hcat-cpt-geste')||{getAttribute:function(){return 'Preisnachlass';}}).getAttribute('data-libelle');
        return lib+(geste.t==='pct'?' (-'+geste.v+'%)':'')+(geste.m?' · '+geste.m:'');
      }
      if(!appliedCode) return '';
      return (pdf?'Partnercode ':'Code ')+appliedCode.code+(appliedCode.pct?' (-'+appliedCode.pct+'%)':'');
    }
    function libelleAcompte(){ var g=document.getElementById('hcat-cpt-geste'); return (g && g.getAttribute('data-acompte')) || 'Acompte à la commande'; }
    function libelleOfferte(){ var g=document.getElementById('hcat-cpt-geste'); return (g && g.getAttribute('data-offerte')) || 'Lieferung gratis'; }
    function resetAll(){
      cards.forEach(function(card){
        if(card.getAttribute('data-kind')==='multi'){ card._qty={}; card.querySelector('.hcat-qty').value=0; multiSummary(card); }
        else card.querySelector('.hcat-qty').value=0;
      });
      appliedCode=null;
      geste=null;
      noteInterne=''; motClient=''; (function(){ var n=document.getElementById('hcat-cpt-nt'); if(n) n.value=''; var m=document.getElementById('hcat-cpt-mot'); if(m){ m.value=''; } })();
      acompte=0; (function(){ var a=document.getElementById('hcat-cpt-ac'); if(a) a.value=''; })();
      portOffert=false; (function(){ var c=document.getElementById('hcat-cpt-po'); if(c) c.checked=false; })();
      portManuel=null; (function(){ var c=document.getElementById('hcat-cpt-ps'); if(c) c.value=''; })();
      presta=null; prestaDeplier(false);
      ['hcat-cpt-pr-lib','hcat-cpt-pr-qte','hcat-cpt-pr-pu'].forEach(function(id){
        var e=document.getElementById(id); if(e) e.value=''; });
      (function(){ var u=document.getElementById('hcat-cpt-pr-u'); if(u) u.value='forfait'; })();
      presta=null; ['hcat-cpt-pr-lib','hcat-cpt-pr-qte','hcat-cpt-pr-pu'].forEach(function(id){ var el=document.getElementById(id); if(el) el.value=''; });
      (function(){ var u=document.getElementById('hcat-cpt-pr-u'); if(u) u.value='forfait'; var o=document.getElementById('hcat-cpt-pr-ok'); if(o) o.hidden=true; })();
      ['hcat-cpt-gc-v','hcat-cpt-gc-m'].forEach(function(id){ var el=document.getElementById(id); if(el) el.value=''; });
      ['hcat-code','hcat-code-m'].forEach(function(id){ var el=document.getElementById(id); if(el) el.value=''; });
      ['hcat-code-msg','hcat-code-msg-m'].forEach(function(id){ var el=document.getElementById(id); if(el){ el.textContent=''; el.className=''; } });
      if(ignifMain) ignifMain.checked=false; if(ignifModal) ignifModal.checked=false;
      shipMode='livraison';
      Array.prototype.forEach.call(document.querySelectorAll('input[name="hcat-ship"],input[name="hcat-ship-m"]'),function(r){ r.checked=(r.value==='livraison'); });
    }

    /* --- reprise d'un devis : numéro DEV-... (serveur) ou lien/code base64 --- */
    function chercherClient(q, msgEl, opts){
      opts=opts||{};
      var boite=opts.boite||document.getElementById('hcat-resume-res'), champ=document.getElementById('hcat-resume-in'), info=opts.info||msgEl;
      info.textContent=opts.charge||'…'; info.className='';
      (opts.promesse || fetch(DEVIS_API+'-recherche',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({q:q,vendeur:VENDEUR,arch:opts.arch===true})})
        .then(function(r){ return r.json(); }))
        .then(function(d){
          info.textContent='';
          boite.innerHTML='';
          var res=(d && d.resultats)||[];
          if(!res.length){ info.textContent=champ.getAttribute('data-aucun'); info.className='ko'; boite.hidden=true; return; }
          res.forEach(function(x){
            var bt=document.createElement('button'); bt.type='button'; bt.className='hcat-suggest-l';
            var n=document.createElement('b'); n.textContent=(x.soc||x.nom||x.em||x.num); bt.appendChild(n);
            /* 18/09/2026 : un devis deja accepte par le client se voit dans la liste, avant
               tout le reste. C'est celui-la qu'on transforme en commande. */
            var etatTxt=[x.accord && x.accord.nom ? champ.getAttribute('data-etat-accord')+' '+x.accord.nom : '',
                         x.etat ? champ.getAttribute('data-etat-'+x.etat) : '',
                         x.archive ? champ.getAttribute('data-etat-archive') : ''].filter(Boolean).join(' · ');
            var par=(x.par||'').split('@')[0].toUpperCase();
            var sp=document.createElement('span'); sp.textContent=[x.num, x.date, x.total?euro(x.total)+' HT':'', x.nom, par, etatTxt].filter(Boolean).join(' · '); bt.appendChild(sp);
            if(x.note){ var nn=document.createElement('em'); nn.className='hcat-suggest-note'; nn.textContent=x.note; bt.appendChild(nn); }
            bt.addEventListener('click',function(ev){ if(bt._glisse){ ev.preventDefault(); bt._glisse=false; return; } if(opts.apres) opts.apres(); else boite.hidden=true; notePendante = x.note || ''; loadByRef('?devis='+x.num+(x.t?'#t='+x.t:''), msgEl, x.cl); });
            if(opts.archivable){
              /* 17/09/2026, Charles : « glisser vers la gauche pour archiver ». Rien n'est
                 efface : le devis sort de la liste, « Annuler » le remet. */
              var rang=document.createElement('div'); rang.className='hcat-glisse';
              var fond=document.createElement('div'); fond.className='hcat-glisse-fond'; fond.textContent=boite.getAttribute('data-archiver'); rang.appendChild(fond);
              rang.appendChild(bt);
              var souris=document.createElement('button'); souris.type='button'; souris.className='hcat-glisse-souris'; souris.textContent=boite.getAttribute('data-archiver'); rang.appendChild(souris);
              var archiver=function(){
                rang.classList.add('is-parti');
                fetch(DEVIS_API+'-archiver',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({num:x.num,archive:true,vendeur:VENDEUR})})
                  .then(function(r){ return r.json(); })
                  .then(function(rep){
                    if(!rep || !rep.ok){ rang.classList.remove('is-parti'); bt.style.transform=''; return; }
                    setTimeout(function(){ if(rang.parentNode) rang.parentNode.removeChild(rang); },260);
                    info.innerHTML='';
                    info.appendChild(document.createTextNode('✓ '+boite.getAttribute('data-archive-ok')+' · '+(x.soc||x.num)+' '));
                    var ann=document.createElement('button'); ann.type='button'; ann.className='hcat-annuler'; ann.textContent=boite.getAttribute('data-annuler');
                    ann.addEventListener('click',function(){
                      fetch(DEVIS_API+'-archiver',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({num:x.num,archive:false,vendeur:VENDEUR})})
                        .then(function(){ info.textContent=''; if(opts.surArchive) opts.surArchive(true); });
                    });
                    info.appendChild(ann);
                    if(opts.surArchive) opts.surArchive(false);
                  })
                  .catch(function(){ rang.classList.remove('is-parti'); bt.style.transform=''; });
              };
              souris.addEventListener('click',archiver);
              var x0=0, y0=0, dx=0, suivi=false;
              bt.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; y0=e.touches[0].clientY; dx=0; suivi=false; bt.style.transition='none'; },{passive:true});
              bt.addEventListener('touchmove',function(e){
                var mx=e.touches[0].clientX-x0, my=e.touches[0].clientY-y0;
                if(!suivi && Math.abs(mx)>12 && Math.abs(mx)>Math.abs(my)) suivi=true;
                if(suivi){ dx=Math.min(0,mx); bt.style.transform='translateX('+dx+'px)'; rang.classList.toggle('is-pret', dx<-90); }
              },{passive:true});
              bt.addEventListener('touchend',function(){
                bt.style.transition='';
                if(suivi){ bt._glisse=true; setTimeout(function(){ bt._glisse=false; },400); }
                if(suivi && dx<-90){ bt.style.transform='translateX(-110%)'; archiver(); }
                else { bt.style.transform=''; rang.classList.remove('is-pret'); }
              });
              boite.appendChild(rang);
            } else boite.appendChild(bt);
          });
          boite.hidden=false;
        })
        .catch(function(){ info.textContent='…'; info.className='ko'; });
    }
    function loadByRef(ref, msgEl, clVendeur){
      ref=(ref||'').trim();
      var jetonColle=''; var mj=ref.match(/[#&]t=([0-9a-f]{16,64})/i); if(mj){ jetonColle=mj[1]; }
      var m=ref.match(/[?&]devis=([^&\s#]+)/); if(m){ try{ ref=decodeURIComponent(m[1]); }catch(e){ ref=m[1]; } }
      if(!ref){ if(msgEl){ msgEl.textContent='Fügen Sie eine Angebotsnummer oder einen Link ein'; msgEl.className='ko'; } return; }
      /* 17/09/2026. Un associe peut aussi taper le NOM du client : la liste de ses devis
         s'affiche, et un clic reprend le devis complet (avec son jeton). */
      if(VENDEUR && msgEl && !/^DEV-/i.test(ref) && !/[#?&](t|devis)=/.test(ref) && !/^[A-Za-z0-9+\/=_-]{40,}$/.test(ref)){
        chercherClient(ref, msgEl); return;
      }
      if(/^DEV-/i.test(ref)){
        var num=ref.toUpperCase();
        if(msgEl){ msgEl.textContent='Angebot wird gesucht...'; msgEl.className=''; }
        /* 17/09/2026 : une relecture par un associe ne compte pas comme une ouverture client. */
        fetch(DEVIS_API+'?num='+encodeURIComponent(num)+(jetonColle?'&t='+encodeURIComponent(jetonColle):'')+(VENDEUR?'&src=vendeur':''))
          .then(function(r){ return r.json(); })
          .then(function(d){
            if(d && d.found && d.state){
              resetAll(); restoreState(d.state);
              /* Devis sans jeton (anterieur au 16/09) repris par un associe : les coordonnees
                 viennent de la recherche vendeur, deja reservee aux associes prouves. */
              if(d.partiel && clVendeur && VENDEUR){
                ['soc','nom','em','tel','adr','cp','ville','tva'].forEach(function(k){ poserChamp('hcat-cl-'+k, clVendeur[k]||''); });
                d.partiel=false; majBandeauVendeur();
              }
              if(msgEl){
                msgEl.textContent = d.partiel
                  ? 'Devis '+num+' übernommen, Ihre Mengen sind wieder geladen. Vos coordonnées sont protégées : ouvrez le lien reçu par email pour les retrouver.'
                  : 'Devis '+num+' übernommen, Ihre Mengen sind wieder geladen';
                msgEl.className='ok';
              }
            } else if(msgEl){ msgEl.textContent='Angebot nicht gefunden, prüfen Sie die Nummer'; msgEl.className='ko'; }
          })
          .catch(function(){ if(msgEl){ msgEl.textContent='Prüfung nicht möglich, versuchen Sie es erneut'; msgEl.className='ko'; } });
      } else {
        try{
          var st=JSON.parse(decodeURIComponent(escape(atob(ref))));
          resetAll(); restoreState(st);
          if(msgEl){ msgEl.textContent='Schätzung neu geladen'; msgEl.className='ok'; }
        }catch(e){ if(msgEl){ msgEl.textContent='Referenz nicht erkannt'; msgEl.className='ko'; } }
      }
    }
    var rT=document.getElementById('hcat-resume-toggle'), rW=document.getElementById('hcat-resume-wrap'),
        rI=document.getElementById('hcat-resume-in'), rB=document.getElementById('hcat-resume-btn'), rM=document.getElementById('hcat-resume-msg');
    if(rT){ rT.addEventListener('click',function(e){ e.preventDefault(); rW.classList.toggle('is-open'); if(rW.classList.contains('is-open')) rI.focus(); }); }
    if(rI && VENDEUR && rI.getAttribute('data-vendeur')) rI.placeholder=rI.getAttribute('data-vendeur');
    if(rB){
      rB.addEventListener('click',function(){ loadByRef(rI.value, rM); });
      rI.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); loadByRef(rI.value, rM); } });
    }

    cards.forEach(function(card){
      if(card.getAttribute('data-kind')==='multi'){
        card._qty={};
        var sel=card.querySelector('.hcat-size');
        var qi=card.querySelector('.hcat-qty');
        paint(card);
        sel.addEventListener('change',function(){
          paint(card); swapImg(card);
          qi.value=card._qty[sel.value]||0;
        });
        qi.addEventListener('input',function(){
          var v=parseInt(qi.value,10)||0; if(v<0){v=0;qi.value=0;}
          card._qty[sel.value]=v; multiSummary(card); recalc();
        });
        card.querySelector('.hcat-minus').addEventListener('click',function(){
          var v=Math.max(0,(parseInt(qi.value,10)||0)-1); qi.value=v; card._qty[sel.value]=v; multiSummary(card); recalc();
        });
        card.querySelector('.hcat-plus').addEventListener('click',function(){
          var v=(parseInt(qi.value,10)||0)+1; qi.value=v; card._qty[sel.value]=v; multiSummary(card); recalc();
        });
      } else {
        paint(card);
        card.querySelector('.hcat-qty').addEventListener('input',recalc);
        card.querySelector('.hcat-minus').addEventListener('click',function(){var q=card.querySelector('.hcat-qty');q.value=Math.max(0,(parseInt(q.value,10)||0)-1);recalc();});
        card.querySelector('.hcat-plus').addEventListener('click',function(){var q=card.querySelector('.hcat-qty');q.value=(parseInt(q.value,10)||0)+1;recalc();});
      }
    });

    /* 23/09/2026, decision de Charles : le traitement anti-feu est fait par un atelier
       FRANCAIS. Pour une livraison ailleurs, il faudrait faire sortir les Pflanzes, les
       envoyer a l'atelier, les ramener, puis les exporter : on ne sait pas le faire a
       un prix tenable. L'option ne vit donc que pour une livraison en France. Le serveur
       refuse de son cote, ici on l'explique au lieu de laisser cocher pour rien. */
    function paysLivraison(){ return ((livr && livr.meme === false ? livr.pays : client.pays) || 'FR').toUpperCase(); }
    function ignifPossible(){ return paysLivraison() === 'FR'; }
    var IGNIF_HORS_FR = 'Die Flammschutzbehandlung gilt nur für Lieferungen in Frankreich: unsere Werkstatt ist französisch. Schreiben Sie uns für eine Lieferung anderswohin.';
    function majIgnifPays(){
      var ok = ignifPossible();
      [ignifMain, ignifModal].forEach(function(c){
        if(!c) return;
        if(!ok && c.checked) c.checked = false;
        c.disabled = !ok;
        var l = c.closest ? c.closest('label') : null;
        if(l){
          l.classList.toggle('hcat-opt-ko', !ok);
          var n = l.querySelector('.hcat-ignif-note');
          if(!ok && !n){ n = document.createElement('span'); n.className = 'hcat-ignif-note'; n.textContent = ' ' + IGNIF_HORS_FR; l.appendChild(n); }
          if(ok && n) n.remove();
        }
      });
    }
    /* ignif : deux cases synchronisées (bloc options + popup) */
    function setIgnif(v){ if(ignifMain) ignifMain.checked=v && ignifPossible(); if(ignifModal) ignifModal.checked=ignifMain?ignifMain.checked:false; majIgnifPays(); recalc(); }
    majIgnifPays();   /* au chargement : le pays par defaut decide de l'etat de la case */
    if(ignifMain) ignifMain.addEventListener('change',function(){ setIgnif(ignifMain.checked); });
    if(ignifModal) ignifModal.addEventListener('change',function(){ setIgnif(ignifModal.checked); });

    /* mode de livraison : radios synchronisées (bloc options + popup) */
    function setShipMode(v){
      shipMode=v;
      Array.prototype.forEach.call(document.querySelectorAll('input[name="hcat-ship"],input[name="hcat-ship-m"]'),function(r){ r.checked=(r.value===v); });
      recalc();
    }
    Array.prototype.forEach.call(document.querySelectorAll('input[name="hcat-ship"],input[name="hcat-ship-m"]'),function(r){
      r.addEventListener('change',function(){ if(r.checked) setShipMode(r.value); });
    });

    /* code partenaire : lien discret + logique partagée */
    function wireCode(toggleId, wrapId, inputId, btnId, msgId){
      var t=document.getElementById(toggleId), w=document.getElementById(wrapId),
          i=document.getElementById(inputId), b=document.getElementById(btnId), m=document.getElementById(msgId);
      if(!t) return;
      t.addEventListener('click',function(e){ e.preventDefault(); w.classList.toggle('is-open'); if(w.classList.contains('is-open')) i.focus(); });
      b.addEventListener('click',function(){
        var code=(i.value||'').trim().toUpperCase();
        if(!code){ appliedCode=null; m.textContent=''; m.className=''; recalc(); return; }
        m.textContent='Prüfung...'; m.className='';
        fetch(CODE_API+'?code='+encodeURIComponent(code))
          .then(function(r){ return r.json(); })
          .then(function(d){
            if(d && d.valid){
              appliedCode = d.type==='pct' ? {code:d.code,pct:d.pct} : {code:d.code,amountCents:d.amountCents};
              m.textContent = d.type==='pct' ? ('Code angewendet: -'+d.pct+'%') : ('Code angewendet: -'+euro(Math.round(d.amountCents/(1+VAT)))+' HT');
              m.className='ok';
            } else {
              appliedCode=null;
              m.textContent = (d && d.reason==='expired') ? 'Code abgelaufen' : 'Code unbekannt';
              m.className='ko';
            }
            recalc();
          })
          .catch(function(){ appliedCode=null; m.textContent='Prüfung nicht möglich, versuchen Sie es erneut'; m.className='ko'; recalc(); });
      });
    }
    wireCode('hcat-code-toggle','hcat-code-wrap','hcat-code','hcat-code-btn','hcat-code-msg');
    wireCode('hcat-code-toggle-m','hcat-code-wrap-m','hcat-code-m','hcat-code-btn-m','hcat-code-msg-m');
    /* 21/10/2026, programme d'apporteurs. Le lien hopercollection.com/discount/CODE pose le
       cookie Shopify « discount_code ». Un client arrive ainsi au catalogue pro retrouve le
       code saisi et verifie, comme s'il l'avait tape lui-meme. On ne touche a rien quand un
       devis est ouvert par son lien, ni quand le devis garde dans le navigateur porte deja
       un code : le code du devis l'emporte toujours sur celui du lien. */
    (function(){
      try{
        if(new URLSearchParams(location.search).get('devis')) return;
        var garde=null; try{ garde=JSON.parse(localStorage.getItem('hcat:v1')||'null'); }catch(e){}
        if(garde && garde.code) return;
        var m=document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
        if(!m) return;
        var code=decodeURIComponent(m[1]).trim().toUpperCase();
        if(!/^[A-Z0-9_-]{2,40}$/.test(code)) return;
        var i1=document.getElementById('hcat-code'), b1=document.getElementById('hcat-code-btn');
        if(!i1 || !b1 || (i1.value||'').trim() || appliedCode) return;
        i1.value=code;
        var i2=document.getElementById('hcat-code-m'); if(i2) i2.value=code;
        var w=document.getElementById('hcat-code-wrap'); if(w) w.classList.add('is-open');
        b1.click();
      }catch(e){}
    })();

    /* popup récap */
    function renderModal(){
      document.getElementById('hcat-m-count').textContent = state.items+' Stück'+(state.items>1?'s':'')+(state.plantCount?' dont '+state.plantCount+' Pflanze'+(state.plantCount>1?'s':''):'');
      if(ignifModal) ignifModal.checked = ignifMain ? ignifMain.checked : false;
      Array.prototype.forEach.call(document.querySelectorAll('input[name="hcat-ship-m"]'),function(r){ r.checked=(r.value===shipMode); });
      fillClientFields();
      var h='';
      h+='<div class="row"><span>Tarif professionnel HT (-15%)</span><b>'+euro(state.pro)+'</b></div>';
      if(state.codeRemise>0) h+='<div class="row"><span>'+echappe(libelleRemise())+'</span><b>-'+euro(state.codeRemise)+'</b></div>';
      if(state.ignifTotal>0) h+='<div class="row"><span>Flammschutzbehandlung ('+state.ignifCount+' Pflanze'+(state.ignifCount>1?'s':'')+')</span><b>'+euro(state.ignifTotal)+'</b></div>';
      if(state.prestaTotal>0) h+='<div class="row"><span>'+echappe(prestaLigne())+'</span><b>'+euro(state.prestaTotal)+'</b></div>';
      if(portOffert) h+='<div class="row"><span>'+libelleOfferte()+'</span><b>0,00 €</b></div>';
      else if(shipMode==='retrait') h+='<div class="row"><span>Abholung im Showroom</span><b>Gratis</b></div>';
      else if(!state.portSur) h+='<div class="row"><span>Versand</span><b>bei der Bestätigung berechnet</b></div>';
      else if(state.palettes>0) h+='<div class="row"><span>Palettenlieferung ×'+state.palettes+'</span><b>'+euro(state.ship)+'</b></div>';
      else h+='<div class="row"><span>Livraison'+(portServeur.kg!==null?' ('+portServeur.kg+' kg)':'')+'</span><b>'+euro(state.ship)+'</b></div>';
      h+='<div class="row total"><span>Angebotssumme netto'+((shipMode!=='retrait'&&!state.portSur)?' (hors livraison)':'')+'</span><b>'+euro(state.total)+'</b></div>';
      if(exonereReel()){
        h+='<div class="row"><span class="muted">'
          +(horsUE()
             ? 'Keine MwSt., Ausfuhr außerhalb der Europäischen Union (Art. 262 I des französischen Steuergesetzbuchs)'
             : 'Keine MwSt., Reverse-Charge-Verfahren (Art. 262 ter I des französischen Steuergesetzbuchs)')
          +' · Total : '+euro(state.total)+'</span></div>';
      } else if(tvaRegime.exonere){
        h+='<div class="row"><span class="muted">Nummer '+tvaRegime.pays+' gültig, aber die Lieferung geht nach '+paysLivraison()+' : gilt die französische MwSt. MwSt. 20%: '+euro(Math.round(state.total*VAT))+' · Summe inkl. MwSt.: '+euro(state.total+Math.round(state.total*VAT))+'</span></div>';
      } else {
        h+='<div class="row"><span class="muted">MwSt. 20%: '+euro(Math.round(state.total*VAT))+' · Summe inkl. MwSt.: '+euro(state.total+Math.round(state.total*VAT))+'</span></div>';
      }
      /* 22/10/2026 (audit) : la ligne disait « Précommande : expédition début novembre » sur TOUS les
         devis, alors que 32 tailles sur 39 sont en stock et partent sous 48 h. Le moteur ne lit pas
         le stock : on dit la règle, vraie quel que soit le contenu du devis. */
      h+='<div class="row"><span class="muted">Vorrätige Stücke: Versand innerhalb von 48 Stunden. Vorbestellte Stücke: Versand '+dateLangue(EXPEDITION)+'.</span></div>';
      document.getElementById('hcat-m-lines').innerHTML=h;
    }
    /* Le verrou du devis. Le visiteur a compose sa selection et vu son total :
       c'est seulement ici qu'un compte devient necessaire, parce qu'un devis et
       une facture portent le nom et le SIRET d'une societe. Sa selection reste
       dans le navigateur (hcat:v1) et lui revient telle quelle. */
    var mur = document.getElementById('hcat-mur');
    function ouvrirMur(){
      if(!mur) return;
      var c = document.getElementById('hcat-mur-count');
      if(c) c.textContent = state.lines.length
        ? (state.items + (state.items>1?' Stücke':' Stück') + ' · ' + euro(state.pro) + ' netto Warenwert, zu Ihrem Geschäftskundenpreis')
        : '';
      persist();                       // sa selection doit survivre au detour par le compte
      mur.classList.add('is-open');
    }
    document.getElementById('hcat-open').addEventListener('click',function(){
      if(!state.lines.length) return;
      if(!PRO){ ouvrirMur(); return; }
      renderModal(); showStep(1); modal.classList.add('is-open');
    });
    if(mur){
      var murClose=document.getElementById('hcat-mur-close');
      if(murClose) murClose.addEventListener('click',function(){ mur.classList.remove('is-open'); });
      surFond(mur,function(){ mur.classList.remove('is-open'); });
    }
    document.getElementById('hcat-modal-close').addEventListener('click',function(){ modal.classList.remove('is-open'); });
    var resetBtn=document.getElementById('hcat-reset');
    if(resetBtn) resetBtn.addEventListener('click',function(){
      if(!window.confirm('Von vorn beginnen? Ihre aktuelle Auswahl wird gelöscht.')) return;
      resetAll();
      client={soc:'',nom:'',em:'',tel:'',adr:'',adr2:'',cp:'',ville:'',tva:'',pays:'FR'};
      livr={meme:true,nom:'',contact:'',tel:'',adr:'',adr2:'',cp:'',ville:'',pays:'FR'};
      CH_F.forEach(function(k){ var el=document.getElementById('hcat-cl-'+k); if(el) el.value=''; });
      CH_L.forEach(function(k){ var el=document.getElementById('hcat-lv-'+k); if(el) el.value=''; });
      curDevis=null; devisRepris=false;
      try{ localStorage.removeItem('hcat:v1'); }catch(e){}
      try{ history.replaceState(null,'',location.pathname); }catch(e){}
      modal.classList.remove('is-open');
      recalc();
      /* 17/09/2026, Charles : « j'ai fait Vider et ca ne fait rien ». La selection etait bien
         effacee, mais le volet restait ouvert sur l'ancienne ligne : une barre vide n'ecrit plus
         rien, donc le volet n'etait pas redessine. On le redessine et on le ferme. */
      renderSelection();
      var fermeV=document.getElementById('hcat-sel-close');
      if(selModal && selModal.classList.contains('is-open') && fermeV) fermeV.click();
    });
    surFond(modal,function(){ modal.classList.remove('is-open'); });

    /* PDF */
    function buildPdf(num, now, editUrl, ret){
      var doc=new window.jspdf.jsPDF();
      doc.setFont('helvetica','normal');
      doc.setFontSize(22); doc.setTextColor(29,29,27); doc.text('HOPER',14,22);
      doc.setFontSize(11); doc.setTextColor(120,120,120); doc.text('Angebot Nr. '+num,14,30);
      var who=pdfTxt([client.soc,client.nom,client.em].map(function(x){return (x||'').trim();}).filter(Boolean).join(' · '));
      var startY=40;
      if(who){ doc.setFontSize(10); doc.setTextColor(29,29,27); doc.text('Fuer: '+who,14,37,{maxWidth:130}); startY=44; }
      /* 09/09/2026 : le devis ne disait pas OU la marchandise part. Une cliente a
         paye sans qu'on sache ou livrer. L'adresse figure desormais sur le document
         que le client valide. */
      var ou = livr.meme
        ? [client.adr, client.adr2, [client.cp, client.ville].filter(Boolean).join(' '), client.pays]
        : [livr.nom, livr.adr, livr.adr2, [livr.cp, livr.ville].filter(Boolean).join(' '), livr.pays];
      ou = pdfTxt(ou.map(function(x){ return (x||'').trim(); }).filter(Boolean).join(', '));
      if(shipMode==='retrait'){
        doc.setFontSize(9); doc.setTextColor(120,120,120);
        doc.text('Abholung vor Ort, kein Versand',14,startY-1,{maxWidth:130});
        startY+=5;
      } else if(ou){
        doc.setFontSize(9); doc.setTextColor(120,120,120);
        doc.text('Lieferung: '+ou,14,startY-1,{maxWidth:130});
        startY+=5;
      }
      doc.setFontSize(10); doc.setTextColor(120,120,120);
      doc.text(now.toLocaleDateString('fr-FR'),196,22,{align:'right'});
      /* 09/09/2026 : trois durees de validite se contredisaient, et le prix du
         devis mourait avec le tarif de lancement sans que le document le dise. */
      doc.text(pdfTxt(validiteTexte()),196,28,{align:'right'});
      var body=state.lines.map(function(l){ return [pdfTxt(l.name),pdfTxt(l.size),String(l.qty),euroPdf(l.proUnit),euroPdf(l.total)]; });
      doc.autoTable({startY:startY,head:[['Produkt','Groesse','Menge','Einzelpreis netto','Summe netto']],body:body,styles:{fontSize:9,cellPadding:3},headStyles:{fillColor:[47,74,60],textColor:255}});
      var y=doc.lastAutoTable.finalY+10;
      doc.setFontSize(10); doc.setTextColor(120,120,120);
      doc.text('Listenpreis netto: '+euroPdf(state.pub),196,y,{align:'right'});
      doc.setTextColor(29,29,27);
      doc.text('Geschaeftskundenpreis netto (-15%): '+euroPdf(state.pro),196,y+6,{align:'right'});
      doc.setTextColor(47,74,60);
      doc.text('Sie sparen: '+euroPdf(state.pub-state.pro+state.codeRemise),196,y+12,{align:'right'});
      y=y+18;
      if(state.codeRemise>0){ doc.setTextColor(47,74,60); doc.text(pdfTxt(libelleRemise(true))+' : -'+euroPdf(state.codeRemise),196,y,{align:'right'}); y+=6; }
      if(state.ignifTotal>0){ doc.setTextColor(29,29,27); doc.text('Flammschutzbehandlung, Zertifikat ausgestellt ('+state.ignifCount+' Pflanze'+(state.ignifCount>1?'s':'')+') : '+euroPdf(state.ignifTotal),196,y,{align:'right'}); y+=6; }
      if(state.prestaTotal>0){ doc.setTextColor(29,29,27); doc.text(pdfTxt(prestaLigne())+' : '+euroPdf(state.prestaTotal),196,y,{align:'right'}); y+=6; }
      if(portOffert){ doc.setTextColor(47,74,60); doc.text(pdfTxt(libelleOfferte())+' : 0,00 EUR',196,y,{align:'right'}); y+=6; }
      else if(shipMode==='retrait'){ doc.setTextColor(29,29,27); doc.text('Abholung im Showroom: Gratis',196,y,{align:'right'}); y+=6; }
      else if(!state.portSur){ doc.setTextColor(29,29,27); doc.text('Lieferung: bei der Bestaetigung berechnet',196,y,{align:'right'}); y+=6; }
      else if(state.palettes>0){ doc.setTextColor(29,29,27); doc.text('Palettenlieferung ('+state.palettes+' palette'+(state.palettes>1?'s':'')+') : '+euroPdf(state.ship),196,y,{align:'right'}); y+=6; }
      /* 15/10/2026 : le poids n'est ecrit QUE si le bareme l'a donne. Le volet a l'ecran
         posait deja cette garde, le PDF non : avec un port impose sur une destination
         hors grille, le devis partait au client avec « Lieferung (null kg) ». */
      /* Le poids n'est imprime que s'il correspond a la selection ACTUELLE. Avec un port
         impose, portSur passe a vrai meme pendant que le bareme est encore en vol : le PDF
         imprimait alors le poids de la selection PRECEDENTE, a cote d'un prix juste. */
      else { var kgFrais = (portServeur.kg!==null && portServeur.sig===signaturePort());
             doc.setTextColor(29,29,27); doc.text('Livraison'+(kgFrais?' ('+portServeur.kg+' kg)':'')+' : '+euroPdf(state.ship),196,y,{align:'right'}); y+=6; }
      doc.setDrawColor(210,210,210); doc.line(120,y+2,196,y+2);
      var tva=exonereReel()?0:Math.round(state.total*VAT);
      doc.setFontSize(10); doc.setTextColor(120,120,120);
      doc.text('Zwischensumme netto'+((shipMode!=='retrait'&&!state.portSur)?' (hors livraison)':'')+' : '+euroPdf(state.total),196,y+8,{align:'right'});
      doc.text(exonereReel()?(horsUE()?'Keine MwSt., Ausfuhr ausserhalb der EU':'Keine MwSt., Reverse-Charge-Verfahren'):'MwSt. 20%: '+euroPdf(tva),196,y+14,{align:'right'});
      doc.setFontSize(12); doc.setTextColor(29,29,27);
      doc.text((exonereReel()?'Total : ':'Summe inkl. MwSt.: ')+euroPdf(state.total+tva),196,y+22,{align:'right'});
      var notes=[];
      if(state.ignifTotal>0) notes.push('Flammschutzbehandlung mit Zertifikat: eine Woche mehr in der Werkstatt.');
      if(shipMode==='retrait') notes.push('Retrait sur place (showroom) : notre equipe vous contacte pour convenir d\'einen Termin.');
      else if(!state.portSur) notes.push('Der Lieferbetrag wird bei der Bestaetigung der Bestellung berechnet, nach tatsaechlichem Gewicht und Lieferadresse.');
      else if(state.palettes>0) notes.push('Palettenlieferung: Entladung ist vom Empfaenger zu organisieren.');
      else notes.push('Lieferung nach tatsaechlichem Gewicht fuer die angegebene Adresse berechnet.');
      if(acompte>0){
        var march=state.total-state.ship, du=Math.round(march*acompte/100);
        notes.push(pdfTxt('Anzahlung bei Bestellung (' + acompte + ' %): ' + euroPdf(du) + ' netto. Restbetrag vor Versand: ' + euroPdf(march-du+state.ship) + ' netto.'));
      }
      notes.push(pdfTxt('Vorraetige Stuecke: Versand innerhalb von 48 Stunden. Vorbestellte Stuecke: Versand ' + dateLangue(EXPEDITION) + '. ' + validiteTexte() + '.'));
      notes.push(pdfTxt('HOPER, societe par actions simplifiee au capital de 1 000 EUR, 47 rue Vivienne, 75002 Paris. RCS Paris 107 281 107. TVA FR49107281107. pro@hopercollection.com'));
      doc.setFontSize(8); doc.setTextColor(150,150,150);
      doc.text(notes.join(' '),14,y+32,{maxWidth:182});
      var by=y+44; if(by+48>288){ doc.addPage(); by=24; }
      var pdfBtns=[
        ['Bestellen und online bezahlen', editUrl+'&action=commander', true],
        ['Proformarechnung erhalten (Ueberweisung)', editUrl+'&action=facture', false],
        ['Dieses Angebot online bearbeiten', editUrl, false]
      ];
      doc.setFontSize(10);
      for(var pi=0; pi<pdfBtns.length; pi++){
        var bl=pdfBtns[pi][0], bu=pdfBtns[pi][1], primary=pdfBtns[pi][2];
        var bw=doc.getTextWidth(bl)+16, bh=11;
        if(primary){
          doc.setFillColor(47,74,60);
          doc.roundedRect(14,by,bw,bh,5.5,5.5,'F');
          doc.setTextColor(255,255,255);
        } else {
          doc.setDrawColor(47,74,60); doc.setLineWidth(0.4);
          doc.roundedRect(14,by,bw,bh,5.5,5.5,'S');
          doc.setTextColor(47,74,60);
        }
        doc.text(bl,14+8,by+7);
        doc.link(14,by,bw,bh,{url:bu});
        by+=bh+5;
      }
      if(ret) return doc;
      var slug = client.soc ? '-'+client.soc.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'') : '';
      doc.save('angebot-hoper'+slug+'.pdf');
    }

    /* 22/09/2026. La planche d'ambiance servait au seul Comptoir. Le client qui ouvre son
       devis la recoit aussi : elle ne revele rien que sa propre selection. */
    function imageDataUrl(src){
      return new Promise(function(ok){
        var im=new Image();
        im.crossOrigin='anonymous';
        im.onload=function(){
          try{
            var c=document.createElement('canvas'); var cote=520;
            c.width=cote; c.height=cote;
            var g=c.getContext('2d'); g.fillStyle='#ffffff'; g.fillRect(0,0,cote,cote);
            var r=Math.min(cote/im.width, cote/im.height);
            var w=im.width*r, h=im.height*r;
            g.drawImage(im,(cote-w)/2,(cote-h)/2,w,h);
            ok(c.toDataURL('image/jpeg',0.82));
          }catch(e){ ok(null); }
        };
        im.onerror=function(){ ok(null); };
        im.src=src;
      });
    }
    function fabriquerPlanche(src, sortie){
      if(!state.lines.length || !window.jspdf) return;
      sortie.textContent=src.getAttribute('data-attente');
      var lignes=lignesSelection();
      Promise.all(lignes.map(function(l){
        var img=l.card.querySelector('.hcat-imgwrap img');
        return img ? imageDataUrl((img.currentSrc||img.src||'').replace(/width=\d+/, 'width=600')) : Promise.resolve(null);
      })).then(function(images){
        var doc=new window.jspdf.jsPDF();
        doc.setFont('helvetica','normal'); doc.setFontSize(20); doc.setTextColor(29,29,27);
        doc.text(pdfTxt(src.getAttribute('data-titre')),14,22);
        doc.setFontSize(11); doc.setTextColor(120,120,120);
        doc.text(pdfTxt([client.soc||'', new Date().toLocaleDateString('fr-FR')].filter(Boolean).join(' · ')),14,30);
        var x=14, y=38, col=0;
        lignes.forEach(function(l, i){
          if(y>215){ doc.addPage(); y=22; x=14; col=0; }
          if(images[i]) doc.addImage(images[i],'JPEG',x,y,85,85);
          else { doc.setDrawColor(230,225,215); doc.rect(x,y,85,85); }
          doc.setFontSize(10); doc.setTextColor(29,29,27);
          doc.text(pdfTxt(l.name),x,y+92,{maxWidth:85});
          doc.setFontSize(9); doc.setTextColor(120,120,120);
          doc.text(pdfTxt([l.size, l.qty+' x'].filter(Boolean).join(' · ')),x,y+98);
          col++;
          if(col%2===0){ x=14; y+=108; } else { x=110; }
        });
        doc.setFontSize(8); doc.setTextColor(150,150,150);
        doc.text(pdfTxt('HOPER · Pflanzes et fleurs artificielles haut de gamme · pro@hopercollection.com'),14,288);
        doc.save('Planche-HOPER-'+(curDevis&&curDevis.num?curDevis.num:'selection')+'.pdf');
        sortie.textContent='';
      }).catch(function(){ sortie.textContent=''; });
    }

    /* 22/09/2026, Charles : « notre interface Comptoir est top ; cote client il faudrait la
       meme chose, avec des fonctionnalites en moins ». Un client qui ouvre SON devis (lien
       avec jeton) voit son devis et ses actions en tete ; le catalogue, les tuiles et les
       options se cachent, et reviennent sur « Modifier la selection ». Les libelles sont
       ceux, deja traduits, des boutons existants : seuls deux sont nouveaux. */
    function reglerPar(mode){
      renderModal(); modal.classList.add('is-open'); showStep(1);
      if(gotoPay) gotoPay.click();
      var s2=document.getElementById('hcat-step2');
      if(mode && s2 && s2.style.display!=='none'){
        var b=document.getElementById(mode==='cb'?'hcat-order-cb':'hcat-order-vir');
        if(b) b.click();
      }
    }
    function poserModeDevis(num, perime){
      if(VENDEUR || document.getElementById('hcat-mondevis')) return;
      var racine=document.querySelector('.hcat'), ap=document.getElementById('hcat-accord');
      if(!racine || !ap) return;
      var L=function(id){ var e=document.getElementById(id); return e ? (e.textContent||'').replace(/\s+/g,' ').trim() : ''; };
      var quoi=document.getElementById('hcat-accord-quoi');
      var motDevis=quoi ? quoi.getAttribute('data-devis') : '';
      var carte=document.createElement('div'); carte.className='hcat-mondevis'; carte.id='hcat-mondevis';
      var t=document.createElement('p'); t.className='hcat-mondevis-t'; t.textContent=motDevis+' '+num;
      var r=document.createElement('p'); r.className='hcat-mondevis-r';
      var a=document.createElement('div'); a.className='hcat-mondevis-a';
      var out=document.createElement('p'); out.className='hcat-mondevis-out'; out.setAttribute('aria-live','polite');
      var bouton=function(txt, cls, fn){ var b=document.createElement('button'); b.type='button'; b.className=cls; b.textContent=txt; b.addEventListener('click',fn); a.appendChild(b); return b; };
      /* 22/09/2026, repasse : un devis perime ne se regle pas en ligne. Le bandeau de
         validite le dit deja et le bon pour accord est masque ; le bouton de reglement
         contredisait les deux. Le client garde le PDF, la planche et la modification. */
      if(!perime) bouton(L('hcat-goto-pay'),'hcat-cpt-btn',function(){ reglerPar(null); });
      bouton(L('hcat-download'),'hcat-cpt-btn2',function(){ if(dlBtn) dlBtn.click(); });
      var srcP=document.getElementById('hcat-cpt-planche');
      if(srcP){
        var bP=bouton(L('hcat-cpt-planche'),'hcat-cpt-btn2',function(){
          if(!window.jspdf){ attendrePdf(bP); return; }
          fabriquerPlanche(srcP, out);
        });
      }
      var LIB_MOD='Auswahl ändern', LIB_RET='Zurück zu meinem Angebot';
      var bM=bouton(LIB_MOD,'hcat-cpt-btn2 hcat-mondevis-mod',function(){
        var voir=racine.classList.contains('hcat-mode-devis');
        racine.classList.toggle('hcat-mode-devis', !voir);
        bM.textContent = voir ? LIB_RET : LIB_MOD;
        if(voir){ var c=document.getElementById('hcat-catalogue'); if(c) c.scrollIntoView({behavior:'smooth'}); }
        else carte.scrollIntoView({behavior:'smooth',block:'center'});
      });
      carte.appendChild(t); carte.appendChild(r); carte.appendChild(a); carte.appendChild(out);
      ap.parentNode.insertBefore(carte, ap.nextSibling);
      racine.classList.add('hcat-mode-devis');
      /* Le montant est celui du DEVIS, Lieferung inklusive : c'est celui que la fenetre
         d'accord presente et que le client paie. La pastille du bas, elle, montre les
         pieces seules ; afficher l'un pour l'autre faisait lire deux totaux differents. */
      var LIB_PORT='Lieferung inklusive';
      majCarteDevis=function(){
        var n=document.querySelector('#hcat-bar .hcat-bar-count');
        var ht=quoi ? quoi.getAttribute('data-ht') : 'HT';
        r.textContent=(n ? (n.textContent||'').trim()+' · ' : '')+euro(state.total||0)+' '+ht
                     +(state.ship>0 ? ', '+LIB_PORT : '');
      };
      majCarteDevis();
    }

    /* --- devis courant : numéro + sauvegarde serveur (partagé PDF / email) --- */
    function ensureDevis(cb){
      if(curDevis){
        /* 22/09/2026, reproduit en ligne : apres une modification, le PDF sortait avec la
           nouvelle selection sous le bon numero, mais le serveur gardait l'ancienne. Un
           accord donne ensuite aurait porte sur un contenu que le client n'avait plus
           sous les yeux. On reecrit donc d'abord, avec le jeton. */
        if(devisModifie && curDevis.jeton){
          devisModifie=false;
          var fini=function(){ cb(curDevis); };
          fetch(DEVIS_API+'?t='+encodeURIComponent(curDevis.jeton),{method:'POST',headers:{'Content-Type':'application/json'},
                body:JSON.stringify({num:curDevis.num,state:collectState(),vendeur:VENDEUR||undefined})}).then(fini,fini);
          return;
        }
        cb(curDevis); return;
      }
      var now=new Date();
      var suf=''; var AB='ABCDEFGHJKMNPQRSTUVWXYZ23456789';
      for(var si=0;si<3;si++){ suf+=AB[Math.floor(Math.random()*AB.length)]; }
      var num='DEV-'+now.getFullYear()+('0'+(now.getMonth()+1)).slice(-2)+('0'+now.getDate()).slice(-2)+'-'+('0'+now.getHours()).slice(-2)+('0'+now.getMinutes()).slice(-2)+'-'+suf;
      var st=collectState();
      var longUrl=location.origin+location.pathname+'?devis='+encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(st)))));
      var shortUrl=location.origin+location.pathname+'?devis='+num;
      var fin=function(editUrl,jeton){
        curDevis={num:num, now:now, editUrl:editUrl, jeton:jeton||''};
        showNum(num);
        /* 18/09/2026. UN DEVIS ENREGISTRE EST LA CONVERSION DU PARCOURS PRO. Une vente pro
           arrive des semaines plus tard : sans ce signal, la campagne Google professionnelle
           se pilote a l'aveugle. On declare 25 % du montant HT, pas 100 % : un devis n'est
           pas une vente, et annoncer le total ferait croire a une rentabilite qui n'existe
           pas encore. Le coefficient sera remplace par le vrai taux des qu'on aura des
           devis suivis. Rien n'est envoye si le visiteur a refuse les cookies : gtag
           respecte le consentement, et nous n'ecrivons pas par-dessus. */
        try{
          var htC = (st && st.totals && st.totals.total) || 0;   /* le total HT du devis, en centimes */
          if(window.gtag && htC > 0){
            window.gtag('event','conversion',{
              send_to: 'AW-18195213018/0fLQCIq0-vscENrVk-RD',
              value: Math.round(htC * 0.25) / 100,
              currency: 'EUR',
              transaction_id: num });
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({event:'devis_pro_enregistre', devis_num:num, devis_ht:htC/100});
        }catch(e){}
        cb(curDevis);
      };
      fetch(DEVIS_API,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({num:num,state:st,vendeur:VENDEUR||undefined})})
        .then(function(r){ return r.json(); })
        .then(function(d){
          /* 16/09/2026 : le numero ne suffit plus a lire les coordonnees du client. Le
             serveur rend un jeton a la creation, et c'est lui qui voyage dans le lien,
             apres le diese, donc jamais dans les journaux du site ni dans le referent. */
          var jeton=(d && d.t) ? String(d.t) : '';
          fin(d && d.ok ? (shortUrl + (jeton ? '#t='+jeton : '')) : longUrl, jeton);
        })
        .catch(function(){ fin(longUrl,''); });
    }
    function showNum(num){
      var line=document.getElementById('hcat-m-afternum'); if(!line) return;
      document.getElementById('hcat-m-num').textContent=num;
      var cp=document.getElementById('hcat-copy-num');
      cp.onclick=function(){
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(num).then(function(){ cp.textContent='Kopiert!'; setTimeout(function(){ cp.textContent='Nummer kopieren'; },2000); },function(){});
        }
      };
      line.classList.add('is-on');
    }

    /* --- Comptoir : mode vendeur du meme ecran, 16/09/2026 ---------------------
       Devant un client, un vendeur a besoin d'UN geste : enregistrer, et repartir
       avec le lien. Pas d'un menu, pas d'un second ecran a maintenir.
       Le bloc n'apparait que si la page l'a autorise, pour un compte interne connu.
       Ce drapeau ne garde rien de sensible : il n'ouvre qu'une aide a la composition,
       et les ecritures qui comptent sont gardees cote serveur.
       Il n'envoie JAMAIS rien : le Comptoir reste donc utilisable pendant le gel.
       Le devis passe par ensureDevis, comme toutes les autres actions : meme numero,
       meme jeton, meme lien que celui que le client recevra. */
    var cptWrap=document.getElementById('hcat-cpt');
    if(cptWrap && window.HOPER_CFG && window.HOPER_CFG.comptoir){
      cptWrap.style.display='';
      var gcV=document.getElementById('hcat-cpt-gc-v'), gcT=document.getElementById('hcat-cpt-gc-t'), gcM=document.getElementById('hcat-cpt-gc-m');
      var lireGeste=function(){
        var v=parseFloat(String(gcV.value||'').replace(',','.'));
        geste=(isFinite(v) && v>0 && !(gcT.value==='pct' && v>=100)) ? {t:gcT.value, v:Math.round(v*100)/100, m:(gcM.value||'').trim().slice(0,80)} : null;
        recalc(); if(modal.classList.contains('is-open')) renderModal();
        majGesteOk();
      };
      /* 17/09/2026, Charles : « je ne vois pas bien si ca l'applique ». Le geste s'applique
         des la saisie ; cette ligne le confirme, montant et nouveau total a l'appui. */
      var majGesteOk=function(){
        var ok=document.getElementById('hcat-cpt-gc-ok'); if(!ok) return;
        if(geste && state.codeRemise>0){
          ok.textContent='✓ '+ok.getAttribute('data-applique')+' −'+euro(state.codeRemise)+' '+ok.getAttribute('data-ht')+' · '+ok.getAttribute('data-total')+' '+euro(state.total-state.ship)+' '+ok.getAttribute('data-ht');
          ok.hidden=false;
        } else ok.hidden=true;
      };
      /* --- Ligne sur mesure, Comptoir uniquement -------------------------------
         Quatre champs : libelle, quantite, unite, prix unitaire HT. La confirmation
         affiche le NOUVEAU TOTAL et pas seulement le montant : c'est ce qui attrape
         un zero en trop, un plafond seul ne le voit pas.
         15/10/2026, Charles : « plutot que prestation de service, ajouter une ligne sur
         mesure, avec un bouton cliquable qui ouvre ces champs-la ». Le panneau du Comptoir
         est deja long : quatre champs de plus, toujours ouverts pour un cas rare, c'est
         quatre champs a sauter sur chaque devis. Ils vivent donc replies. */
      (function construirePresta(){
        if(!VENDEUR) return;
        var hote=document.getElementById('hcat-cpt-geste');
        if(!hote || document.getElementById('hcat-cpt-pr-lib')) return;
        var L=PRESTA_LIBELLES.split('|');
        var ouvrir=document.createElement('button');
        ouvrir.type='button'; ouvrir.className='hcat-cpt-btn2'; ouvrir.id='hcat-cpt-pr-ouvrir';
        ouvrir.textContent=L[7]; hote.appendChild(ouvrir);
        var boite=document.createElement('div');
        boite.id='hcat-cpt-pr'; boite.hidden=true;
        var lab=document.createElement('label'); lab.className='hcat-cpt-l';
        lab.setAttribute('for','hcat-cpt-pr-lib'); lab.textContent=L[0]; boite.appendChild(lab);
        var lib=document.createElement('input');
        lib.type='text'; lib.id='hcat-cpt-pr-lib'; lib.maxLength=80; lib.placeholder=L[1];
        boite.appendChild(lib);
        var ligne=document.createElement('div'); ligne.className='hcat-cpt-ligne';
        var qte=document.createElement('input');
        qte.type='number'; qte.id='hcat-cpt-pr-qte'; qte.min='0.25'; qte.step='0.25';
        qte.setAttribute('inputmode','decimal'); qte.placeholder=L[2]; ligne.appendChild(qte);
        var sel=document.createElement('select'); sel.id='hcat-cpt-pr-u';
        ['forfait','heure','jour','unite'].forEach(function(k){
          var o=document.createElement('option'); o.value=k; o.textContent=PRESTA_UNITES[k]; sel.appendChild(o);
        });
        ligne.appendChild(sel);
        var pu=document.createElement('input');
        pu.type='number'; pu.id='hcat-cpt-pr-pu'; pu.min='0'; pu.step='0.01';
        pu.setAttribute('inputmode','decimal'); pu.placeholder=L[3]; ligne.appendChild(pu);
        boite.appendChild(ligne);
        var ok=document.createElement('p');
        ok.className='hcat-cpt-ok'; ok.id='hcat-cpt-pr-ok'; ok.hidden=true;
        ok.setAttribute('data-applique', L[4]);
        ok.setAttribute('data-ht', 'HT');
        ok.setAttribute('data-total', L[6]);
        ok.setAttribute('data-incomplet', L[5]);
        boite.appendChild(ok);
        /* Un retrait EXPLICITE. Replier sans vider laisserait une ligne facturee mais
           invisible ; vider en repliant tout seul ferait perdre une saisie en cours. */
        var retirer=document.createElement('button');
        retirer.type='button'; retirer.className='hcat-cpt-btn2'; retirer.id='hcat-cpt-pr-retirer';
        retirer.textContent=L[8]; boite.appendChild(retirer);
        hote.appendChild(boite);
      })();
      var prL=document.getElementById('hcat-cpt-pr-lib'), prQ=document.getElementById('hcat-cpt-pr-qte'),
          prU=document.getElementById('hcat-cpt-pr-u'),  prP=document.getElementById('hcat-cpt-pr-pu');
      var majPrestaOk=function(){
        var ok=document.getElementById('hcat-cpt-pr-ok'); if(!ok) return;
        if(presta && state.prestaTotal>0){
          ok.textContent='✓ '+ok.getAttribute('data-applique')+' '+euro(state.prestaTotal)+' '+ok.getAttribute('data-ht')
                        +' · '+ok.getAttribute('data-total')+' '+euro(state.total-state.ship)+' '+ok.getAttribute('data-ht');
          ok.className='hcat-cpt-ok'; ok.hidden=false;
        } else if(prL && (prL.value||'').trim() && !presta){
          ok.textContent=ok.getAttribute('data-incomplet'); ok.className='hcat-cpt-ok ko'; ok.hidden=false;
        } else ok.hidden=true;
      };
      var lirePresta=function(){
        if(!prL || !VENDEUR){ presta=null; return; }
        var lib=(prL.value||'').trim().slice(0,80);
        var q=parseFloat(String((prQ&&prQ.value)||'').replace(',','.'));
        var pu=parseFloat(String((prP&&prP.value)||'').replace(',','.'));
        var unite=(prU&&prU.value)||'forfait';
        if(unite==='forfait' && !isFinite(q)) q=1;
        var puCents=Math.round(pu*100);
        var bon = lib.length>=3 && isFinite(q) && q>0 && isFinite(pu) && pu>0
                  && Math.round(q*puCents) <= PRESTA_PLAFOND;
        presta = bon ? {lib:lib, qte:Math.round(q*100)/100, unite:unite, puCents:puCents} : null;
        recalc(); if(modal.classList.contains('is-open')) renderModal();
        majPrestaOk();
      };
      [prL, prQ, prU, prP].forEach(function(el){
        if(el) el.addEventListener('input', lirePresta);
        if(el && el.tagName==='SELECT') el.addEventListener('change', lirePresta);
      });

      /* Le volet s'ouvre au clic et ne se referme que sur un retrait explicite. Il s'ouvre
         AUSSI tout seul a la relecture d'un devis qui en porte une : une ligne facturee
         derriere un bouton ferme serait invisible au vendeur qui reprend le dossier. */
      var prOuvrir=document.getElementById('hcat-cpt-pr-ouvrir'),
          prBoite=document.getElementById('hcat-cpt-pr'),
          prRetirer=document.getElementById('hcat-cpt-pr-retirer');
      prestaDeplier=function(ouverte){
        if(prBoite) prBoite.hidden=!ouverte;
        if(prOuvrir) prOuvrir.hidden=ouverte;
      };
      if(prOuvrir) prOuvrir.addEventListener('click',function(){
        prestaDeplier(true); if(prL) prL.focus();
      });
      if(prRetirer) prRetirer.addEventListener('click',function(){
        if(prL) prL.value=''; if(prQ) prQ.value=''; if(prP) prP.value='';
        if(prU) prU.value='forfait';
        lirePresta();            /* tout vide : la ligne est retiree du devis */
        prestaDeplier(false);
      });

      /* --- Frais de livraison imposes, Comptoir uniquement ----------------------
         Un seul champ, en euros HT, dans la meme unite que le bareme (state.ship est
         en centimes HT). Vide, le bareme s'applique : c'est l'etat par defaut, et le
         client ne voit aucune difference avec aujourd'hui.
         Construit en JavaScript et non dans le gabarit : catalogue-pro-part1.liquid
         pese 49,4 Ko pour un plafond Shopify de 50 Ko. Meme raison que la prestation. */
      (function construirePort(){
        if(!VENDEUR) return;
        var hote=document.getElementById('hcat-cpt-geste');
        if(!hote || document.getElementById('hcat-cpt-ps')) return;
        var L=PORT_LIBELLES.split('|');
        var boite=document.createElement('div'); boite.id='hcat-cpt-port';
        var lab=document.createElement('label'); lab.className='hcat-cpt-l';
        lab.setAttribute('for','hcat-cpt-ps'); lab.textContent=L[0]; boite.appendChild(lab);
        var inp=document.createElement('input');
        inp.type='number'; inp.id='hcat-cpt-ps'; inp.min='0'; inp.step='0.01';
        inp.setAttribute('inputmode','decimal'); inp.placeholder=L[1];
        boite.appendChild(inp);
        var ok=document.createElement('p');
        ok.className='hcat-cpt-ok'; ok.id='hcat-cpt-ps-ok'; ok.hidden=true;
        ok.setAttribute('data-applique', L[2]);
        ok.setAttribute('data-aulieu', L[3]);
        boite.appendChild(ok);
        hote.appendChild(boite);
      })();
      var psI=document.getElementById('hcat-cpt-ps');
      /* La confirmation dit le montant impose ET celui du bareme qu'il remplace : c'est
         ce qui attrape un zero en trop, qu'un plafond seul ne verrait pas. */
      var majPortOk=function(){
        var ok=document.getElementById('hcat-cpt-ps-ok'); if(!ok) return;
        if(portManuel===null || portOffert){ ok.hidden=true; return; }
        var txt='✓ '+ok.getAttribute('data-applique')+' '+euro(portManuel)+' HT';
        if(portServeur.ht !== null && portServeur.ht !== portManuel)
          txt+=' · '+ok.getAttribute('data-aulieu')+' '+euro(portServeur.ht)+' HT';
        ok.textContent=txt; ok.className='hcat-cpt-ok'; ok.hidden=false;
      };
      var lirePort=function(){
        if(!psI || !VENDEUR){ portManuel=null; return; }
        var brut=String(psI.value||'').trim().replace(',','.');
        var v=parseFloat(brut);
        /* Champ vide : on REVIENT au bareme. Une valeur impossible est ignoree et le
           bareme reprend aussi, plutot que de facturer un nombre qui n'a pas de sens. */
        portManuel = (brut!=='' && isFinite(v) && v>=0 && Math.round(v*100)<=PORT_PLAFOND)
                     ? Math.round(v*100) : null;
      if(portManuel!==null && portOffert){
        portOffert=false;
        var po=document.getElementById('hcat-cpt-po'); if(po) po.checked=false;
      }
        recalc(); if(modal.classList.contains('is-open')) renderModal();
        majPortOk();
      };
      if(psI) psI.addEventListener('input', lirePort);

      var ntC=document.getElementById('hcat-cpt-nt');
      if(ntC) ntC.addEventListener('input',function(){ noteInterne=(ntC.value||'').slice(0,500); });
      /* 17/09/2026, Charles : un message predefini, qu'il peut personnaliser ou effacer.
         On ne le repose jamais par-dessus ce qu'il a ecrit ou efface lui-meme. */
      var motC=document.getElementById('hcat-cpt-mot'), motTouche=false;
      var motDefaut=function(){
        if(!motC) return '';
        var prenom=((client.nom||'').trim().split(/\s+/)[0]||'');
        return prenom ? motC.getAttribute('data-defaut').replace('NOM', prenom) : motC.getAttribute('data-defaut-sans-nom');
      };
      var proposerMot=function(){
        if(!motC || motTouche) return;
        motClient=motDefaut(); motC.value=motClient;
      };
      if(motC) motC.addEventListener('input',function(){ motTouche=true; motClient=(motC.value||'').slice(0,400); });
      /* 17/09/2026, Charles : dupliquer un devis. On garde tout (client, selection, geste) et
         on oublie le numero : le prochain enregistrement en tire un neuf. */
      var dupC=document.getElementById('hcat-cpt-dup');
      if(dupC) dupC.addEventListener('click',function(){
        curDevis=null;
        cptOut.textContent='✓ '+dupC.getAttribute('data-fait');
      });
      /* 18/09/2026, Charles : « l'historique client, c'est top ». Tout existe deja ailleurs :
         les commandes et le total achete chez Shopify, les devis dans le KV. On ne recopie
         RIEN, on assemble a l'ecran. La fenetre est construite ici pour ne pas alourdir la
         section Liquid, plafonnee a 50 Ko par Shopify. */
      var histB=document.getElementById('hcat-cpt-histo');
      var histFen=null;
      var ouvrirHisto=function(){
        if(!histFen){
          histFen=document.createElement('div');
          histFen.className='hcat-modal hcat-volet'; histFen.id='hcat-histo';
          histFen.setAttribute('role','dialog'); histFen.setAttribute('aria-modal','true');
          var carte=document.createElement('div'); carte.className='hcat-modal-card hcat-sel-card';
          var poignee=document.createElement('span'); poignee.className='hcat-volet-poignee'; carte.appendChild(poignee);
          var fermer=document.createElement('button'); fermer.className='hcat-modal-close'; fermer.type='button';
          fermer.innerHTML='&times;'; carte.appendChild(fermer);
          var titre=document.createElement('p'); titre.className='hcat-modal-title';
          titre.textContent=histB.getAttribute('data-titre'); carte.appendChild(titre);
          var sous=document.createElement('p'); sous.className='hcat-modal-sub'; sous.id='hcat-histo-sous'; carte.appendChild(sous);
          var corps=document.createElement('div'); corps.className='hcat-histo-corps'; corps.id='hcat-histo-corps'; carte.appendChild(corps);
          histFen.appendChild(carte); document.body.appendChild(histFen);
          var clore=function(){ histFen.classList.remove('is-open'); document.documentElement.classList.remove('hcat-fige'); };
          fermer.addEventListener('click',clore);
          surFond(histFen,function(){ clore(); });
          document.addEventListener('keydown',function(e){ if(e.key==='Escape' && histFen.classList.contains('is-open')) clore(); });
        }
        histFen.classList.add('is-open'); document.documentElement.classList.add('hcat-fige');
      };
      var ligneHisto=function(gauche, droite, fort){
        var l=document.createElement('div'); l.className='hcat-histo-l';
        var a=document.createElement('span'); a.textContent=gauche; if(fort) a.className='hcat-histo-fort';
        var b=document.createElement('span'); b.className='hcat-histo-d'; b.textContent=droite;
        l.appendChild(a); l.appendChild(b); return l;
      };
      var titreHisto=function(t){ var h=document.createElement('p'); h.className='hcat-histo-t'; h.textContent=t; return h; };
      if(histB) histB.addEventListener('click',function(){
        var em=(client.em||'').trim();
        if(!em){ cptOut.textContent=histB.getAttribute('data-sans-client'); return; }
        ouvrirHisto();
        var corps=document.getElementById('hcat-histo-corps'), sous=document.getElementById('hcat-histo-sous');
        corps.innerHTML=''; sous.textContent=histB.getAttribute('data-attente');
        var dateCourte=function(iso){ var d=new Date(iso); return isNaN(d.getTime()) ? '' : d.toLocaleDateString(
          (document.documentElement.lang||'').toLowerCase().indexOf('en')===0 ? 'en-GB' : 'fr-FR',
          {day:'2-digit',month:'2-digit',year:'numeric'}); };
        Promise.all([
          fetch(DEVIS_API.replace(/\/pro\/devis$/,'/pro/client-histoire'),
                {method:'POST',headers:{'Content-Type':'application/json'},
                 body:JSON.stringify({em:em, vendeur:VENDEUR})}).then(function(r){ return r.json(); }),
          fetch(DEVIS_API+'-recherche',{method:'POST',headers:{'Content-Type':'application/json'},
                 body:JSON.stringify({q:em, vendeur:VENDEUR})}).then(function(r){ return r.json(); })
        ]).then(function(rep){
          var h=rep[0]||{}, dv=(rep[1]||{}).resultats||[];
          corps.innerHTML='';
          if(!h.ok){ sous.textContent=histB.getAttribute('data-erreur'); }
          else if(!h.trouve){ sous.textContent=histB.getAttribute('data-inconnu'); }
          else {
            var soc=h.societe||null, cl=h.client||{};
            /* Le total de la SOCIETE ne compte que ce qui est rattache au compte pro : une
               commande passee en particulier avant l'ouverture du compte n'y figure pas. On
               affiche donc le total de la personne, et la societe en plus quand elle existe. */
            var nomSoc=soc?String(soc.nom||''):'', nomCl=String(cl.nom||em);
            var tete=(nomSoc && nomSoc.toLowerCase()!==nomCl.toLowerCase()) ? nomSoc+' · '+nomCl : (nomSoc||nomCl);
            sous.textContent=tete+' · '+euro(cl.achete||0)+' '+histB.getAttribute('data-achete');
            corps.appendChild(titreHisto(histB.getAttribute('data-cmd')
              +' · '+(cl.commandes_n||0)+' '+histB.getAttribute('data-total-cmd')));
            /* Shopify ne rend que 60 jours de commandes ; la derniere, elle, est toujours
               connue. On la montre donc quand elle sort de cette fenetre, sinon un client
               fidele apparaitrait comme un inconnu. */
            if(h.derniere && !(h.commandes||[]).some(function(o){ return o.num===h.derniere.num; }))
              corps.appendChild(ligneHisto(histB.getAttribute('data-derniere')+' '+h.derniere.num
                +' · '+dateCourte(h.derniere.at), euro(h.derniere.total||0), true));
            if(!(h.commandes||[]).length && !h.derniere) corps.appendChild(ligneHisto(histB.getAttribute('data-aucune'),''));
            (h.commandes||[]).forEach(function(o){
              corps.appendChild(ligneHisto(o.num+' · '+dateCourte(o.at),
                euro(o.total)+' · '+(o.paye?histB.getAttribute('data-paye'):histB.getAttribute('data-impaye')), true));
            });
          }
          corps.appendChild(titreHisto(histB.getAttribute('data-devis')+' ('+dv.length+')'));
          if(!dv.length) corps.appendChild(ligneHisto(histB.getAttribute('data-aucun-devis'),''));
          dv.slice(0,20).forEach(function(x){
            var l=ligneHisto(x.num+' · '+(x.date||''), euro(x.total||0)+' HT', true);
            l.className+=' hcat-histo-cliq';
            l.addEventListener('click',function(){
              histFen.classList.remove('is-open'); document.documentElement.classList.remove('hcat-fige');
              loadByRef('?devis='+x.num+(x.t?'#t='+x.t:''), document.getElementById('hcat-resume-msg'), x.cl);
            });
            corps.appendChild(l);
          });
        }).catch(function(){ sous.textContent=histB.getAttribute('data-erreur'); });
      });
      /* 17/09/2026. PLANCHE D'AMBIANCE : les photos des pieces choisies, pour le decideur
         qui n'etait pas au rendez-vous. Les images viennent de la boutique (CORS ouvert). */
      var planB=document.getElementById('hcat-cpt-planche');
      if(planB) planB.addEventListener('click',function(){ fabriquerPlanche(planB, cptOut); });
      var acC=document.getElementById('hcat-cpt-ac');
      if(acC) acC.addEventListener('input',function(){
        var v=parseFloat(String(acC.value||'').replace(',','.'));
        acompte=(isFinite(v) && v>0 && v<100) ? Math.round(v*10)/10 : 0;
        recalc(); if(modal.classList.contains('is-open')) renderModal(); if(selModal && selModal.classList.contains('is-open')) renderSelection();
      });
      var poC=document.getElementById('hcat-cpt-po');
      /* Les deux s'excluent : un devis portant un prix impose ET la livraison offerte
         facturait zero tout en affichant le prix impose au client qui rouvrait son lien
         sans le jeton. Un devis qui se contredit devant un client ne part pas d'ici. */
      if(poC) poC.addEventListener('change',function(){
        portOffert=poC.checked;
        if(portOffert && portManuel!==null){
          portManuel=null;
          var i=document.getElementById('hcat-cpt-ps'); if(i) i.value='';
        }
        recalc(); if(modal.classList.contains('is-open')) renderModal(); majPortOk(); });
      if(gcV){ [gcV,gcT,gcM].forEach(function(el){ el.addEventListener('input',lireGeste); el.addEventListener('change',lireGeste); }); }
      var cptBtn=document.getElementById('hcat-cpt-save');
      var cptOut=document.getElementById('hcat-cpt-out');
      var cptLabel='Dieses Angebot speichern';
      cptBtn.addEventListener('click',function(){
        if(!state.lines.length){ cptOut.textContent='Fügen Sie mindestens ein Stück hinzu.'; return; }
        cptBtn.disabled=true; cptBtn.textContent='Wird gespeichert…';
        ensureDevis(function(d){
          if(!d || !d.num){ cptBtn.disabled=false; cptBtn.textContent=cptLabel; cptOut.textContent='Speichern nicht möglich, versuchen Sie es erneut.'; return; }
          /* Le devis est reenregistre avec la selection du moment : un numero deja tire ne
             doit pas garder une ancienne selection. */
          fetch(DEVIS_API+(d.jeton?'?t='+encodeURIComponent(d.jeton):''),{method:'POST',headers:{'Content-Type':'application/json'},
                body:JSON.stringify({num:d.num,state:collectState(),vendeur:VENDEUR||undefined})})
            .then(function(){
              cptBtn.disabled=false; cptBtn.textContent=cptLabel;
              var envoiD=document.getElementById('hcat-cpt-envoi');
              afficherResultat(document.getElementById('hcat-cpt-save-res'), d.num,
                {lien:d.editUrl, texte:envoiD.getAttribute('data-texte').replace('NUM',d.num)},
                function(){ try{ if(window.jspdf) buildPdf(d.num, d.now, d.editUrl, true).save('Devis-HOPER-'+d.num+'.pdf'); }catch(e){} });
            })
            .catch(function(){ cptBtn.disabled=false; cptBtn.textContent=cptLabel; cptOut.textContent='Speichern nicht möglich, versuchen Sie es erneut.'; });
        });
      });

      /* Convertir devant le client. On REUTILISE doCheckout, qui porte deja la
         validation de l'adresse, les douze motifs de refus en clair et l'alerte a la
         maison : le Comptoir n'a pas sa propre version du chemin de commande. */
      var cptCb=document.getElementById('hcat-cpt-cb');
      var cptVir=document.getElementById('hcat-cpt-vir');
      var cptMail=document.getElementById('hcat-cpt-mail');
      /* 17/09/2026. Le lien de paiement est cree SANS email : l'associe le copie, le partage
         (WhatsApp, SMS, email du telephone) ou l'envoie avec le devis. Libelles lus dans le
         theme, qui porte les deux langues. */
      /* 17/09/2026, Charles : « il manque votre adresse de livraison, mais aucun endroit pour
         la renseigner ». Le lien carte ouvre d'abord l'adresse de livraison (preremplie),
         puis cree le lien et propose WhatsApp, email, partager ou copier. */
      var envoiDevis=document.getElementById('hcat-cpt-envoi');
      var avecMot=function(t){ return motClient ? (motClient+'\n\n'+t) : t; };
      var boutonsPartage=function(zone, info){
        zone.innerHTML='';
        var A=function(k){ return envoiDevis.getAttribute('data-'+k); };
        var ajoute=function(libelle, action){ var b=document.createElement('button'); b.type='button'; b.className='hcat-cpt-choix'; b.textContent=libelle; b.addEventListener('click',action); zone.appendChild(b); };
        ajoute(A('wa'),function(){ window.open('https://wa.me/?text='+encodeURIComponent(avecMot(info.texte+' '+info.lien)),'_blank'); });
        ajoute(A('mail'),function(){ location.href='mailto:'+encodeURIComponent((client.em||'').trim())+'?subject='+encodeURIComponent(A('sujet'))+'&body='+encodeURIComponent(avecMot(info.texte+'\n'+info.lien)); });
        ajoute(A('partager'),function(){ if(navigator.share) navigator.share({title:A('sujet'), text:avecMot(info.texte), url:info.lien}).catch(function(){}); else if(navigator.clipboard) navigator.clipboard.writeText(info.lien); });
        ajoute(A('copier'),function(){ if(navigator.clipboard) navigator.clipboard.writeText(info.lien).then(function(){ cptOut.textContent=A('copie'); },function(){ cptOut.textContent=info.lien; }); else cptOut.textContent=info.lien; });
        zone.hidden=false;
      };
      /* 17/09/2026, Charles : « ca met un petit lien en bas, on ne le voit pas ». Le resultat
         s'affiche JUSTE SOUS le bouton, en encadre, avec les gestes d'envoi, et l'ecran y va. */
      /* QR code : le client scanne l'ecran et retrouve son devis ou son paiement sur son
         telephone, sans rien taper. La librairie n'est chargee qu'au premier clic. */
      var qrFenetre=document.getElementById('hcat-qr');
      var chargerQR=function(){
        if(window.QRious) return Promise.resolve();
        return new Promise(function(ok, ko){
          var sc=document.createElement('script');
          sc.src='https://cdnjs.cloudflare.com/ajax/libs/qrious/4.0.2/qrious.min.js';
          sc.onload=ok; sc.onerror=ko; document.head.appendChild(sc);
        });
      };
      var montrerQR=function(lien, titre){
        if(!qrFenetre) return;
        chargerQR().then(function(){
          new window.QRious({ element: document.getElementById('hcat-qr-canvas'), value: lien, size: 280,
                              background: '#ffffff', foreground: '#1d1d1b', level: 'M' });
          document.getElementById('hcat-qr-titre').textContent=titre || qrFenetre.getAttribute('data-titre');
          document.getElementById('hcat-qr-lien').textContent=lien;
          qrFenetre.classList.add('is-open');
          document.documentElement.classList.add('hcat-fige');
        }).catch(function(){ cptOut.textContent=lien; });
      };
      if(qrFenetre){
        var fermerQR=function(){ qrFenetre.classList.remove('is-open'); document.documentElement.classList.remove('hcat-fige'); };
        document.getElementById('hcat-qr-close').addEventListener('click',fermerQR);
        surFond(qrFenetre,function(){ fermerQR(); });
        document.addEventListener('keydown',function(e){ if(e.key==='Escape') fermerQR(); });
      }
      var afficherResultat=function(zone, num, info, pdf){
        zone.innerHTML='';
        var t=document.createElement('p'); t.className='hcat-cpt-res-t'; t.textContent='✓ '+zone.getAttribute('data-titre')+' · '+num; zone.appendChild(t);
        var a=document.createElement('a'); a.href=info.lien; a.target='_blank'; a.rel='noopener'; a.className='hcat-cpt-lien'; a.textContent=info.lien; zone.appendChild(a);
        var grille=document.createElement('div'); grille.className='hcat-cpt-envoi'; zone.appendChild(grille);
        boutonsPartage(grille, info);
        if(pdf){ var b=document.createElement('button'); b.type='button'; b.className='hcat-cpt-choix hcat-cpt-choix--pdf'; b.textContent=zone.getAttribute('data-pdf'); b.addEventListener('click',pdf); grille.insertBefore(b, grille.firstChild); }
        var q=document.createElement('button'); q.type='button'; q.className='hcat-cpt-choix'; q.textContent='QR code';
        q.addEventListener('click',function(){ montrerQR(info.lien, num); });
        grille.appendChild(q);
        cptOut.textContent='';
        zone.hidden=false;
        zone.scrollIntoView({behavior:'smooth', block:'center'});
      };
      var carte=document.getElementById('hcat-cpt-carte');
      if(cptCb && carte) cptCb.addEventListener('click',function(){
        if(!state.lines.length) return;
        carte.hidden=!carte.hidden;
        if(carte.hidden) return;
        document.getElementById('hcat-cc-partage').hidden=true;
        var src = livr.meme ? {nom:client.soc, adr:client.adr, cp:client.cp, ville:client.ville, pays:client.pays}
                            : {nom:livr.nom, adr:livr.adr, cp:livr.cp, ville:livr.ville, pays:livr.pays};
        document.getElementById('hcat-cc-nom').value=src.nom||client.soc||'';
        document.getElementById('hcat-cc-adr').value=src.adr||'';
        document.getElementById('hcat-cc-cp').value=src.cp||'';
        document.getElementById('hcat-cc-ville').value=src.ville||'';
        document.getElementById('hcat-cc-pays').value=src.pays||'FR';
      });
      var ccOk=document.getElementById('hcat-cc-ok');
      if(ccOk) ccOk.addEventListener('click',function(){
        var v=function(id){ return (document.getElementById(id).value||'').trim(); };
        if(!v('hcat-cc-adr') || !v('hcat-cc-cp') || !v('hcat-cc-ville')){ cptOut.textContent=carte.getAttribute('data-manque'); return; }
        /* La facturation vide prend cette adresse ; la livraison la prend toujours. */
        if(!(client.adr||'').trim()){ poserChamp('hcat-cl-adr',v('hcat-cc-adr')); poserChamp('hcat-cl-cp',v('hcat-cc-cp')); poserChamp('hcat-cl-ville',v('hcat-cc-ville')); }
        livr.meme=false; livr.nom=v('hcat-cc-nom'); livr.adr=v('hcat-cc-adr'); livr.adr2=''; livr.cp=v('hcat-cc-cp'); livr.ville=v('hcat-cc-ville'); livr.pays=v('hcat-cc-pays')||'FR';
        var me=document.getElementById('hcat-lv-meme'); if(me) me.checked=false;
        ['nom','adr','cp','ville'].forEach(function(k){ var el=document.getElementById('hcat-lv-'+k); if(el) el.value=livr[k]; });
        var lp=document.getElementById('hcat-lv-pays'); if(lp) lp.value=livr.pays;
        persist(); recalc();
        /* Un refus du lien carte s'affiche sous le bouton, comme pour la proforma. */
        if(!ccOk._res){ ccOk._res=document.createElement('div'); ccOk._res.className='hcat-cpt-resultat'; ccOk._res.hidden=true;
          ccOk._res.setAttribute('aria-live','polite'); ccOk.parentNode.insertBefore(ccOk._res, ccOk.nextSibling); }
        ccOk._res.hidden=true;
        doCheckout('cb', ccOk, {comptoir:true, zone:ccOk._res, onLien:function(lien, d){
          afficherResultat(document.getElementById('hcat-cc-partage'), d.num, {lien:lien, texte:carte.getAttribute('data-texte').replace('NUM',d.num)});
        }});
      });
      if(cptVir){
        var virRes=document.createElement('div');
        virRes.className='hcat-cpt-resultat'; virRes.hidden=true; virRes.setAttribute('aria-live','polite');
        cptVir.parentNode.insertBefore(virRes, cptVir.nextSibling);
        cptVir.addEventListener('click',function(){ doCheckout('virement', cptVir, {comptoir:true, zone:virRes}); });
      }
      /* 17/09/2026, Charles en rendez-vous : « une mini pop-up pour choisir mail, WhatsApp,
         AirDrop ». Le devis est PREPARE des l'ouverture du choix (enregistre avec la selection
         du moment, PDF genere) : iPhone n'autorise le partage que pendant le geste lui-meme,
         pas apres une attente reseau. */
      var envoi=document.getElementById('hcat-cpt-envoi'), pret=null;
      var preparerEnvoi=function(){
        pret=null;
        cptOut.textContent=envoi.getAttribute('data-prep');
        ensureDevis(function(d){
          fetch(DEVIS_API+(d.jeton?'?t='+encodeURIComponent(d.jeton):''),{method:'POST',headers:{'Content-Type':'application/json'},
                body:JSON.stringify({num:d.num,state:collectState(),vendeur:VENDEUR||undefined})})
            .then(function(){
              var fichier=null;
              try{
                if(window.jspdf){
                  var blob=buildPdf(d.num, d.now, d.editUrl, true).output('blob');
                  fichier=new File([blob],'Devis-HOPER-'+d.num+'.pdf',{type:'application/pdf'});
                }
              }catch(e){ fichier=null; }
              pret={d:d, fichier:fichier, texte:envoi.getAttribute('data-texte').replace('NUM',d.num)};
              cptOut.textContent='';
            })
            .catch(function(){ cptOut.textContent=envoi.getAttribute('data-ko'); });
        });
      };
      if(cptMail && envoi){
        cptMail.addEventListener('click',function(){
          if(!state.lines.length) return;
          envoi.hidden=!envoi.hidden;
          if(!envoi.hidden) preparerEnvoi();
        });
        document.getElementById('hcat-cpt-env-mail').addEventListener('click',function(){
          envoi.hidden=true; envoyerDevis(cptMail,'comptoir',cptMail.textContent);
        });
        document.getElementById('hcat-cpt-env-wa').addEventListener('click',function(){
          if(!pret){ cptOut.textContent=envoi.getAttribute('data-prep'); return; }
          window.open('https://wa.me/?text='+encodeURIComponent((motClient?motClient+'\n\n':'')+pret.texte+' '+pret.d.editUrl),'_blank');
        });
        document.getElementById('hcat-cpt-env-partage').addEventListener('click',function(){
          if(!pret){ cptOut.textContent=envoi.getAttribute('data-prep'); return; }
          var data={title:'HOPER · '+pret.d.num, text:(motClient?motClient+'\n\n':'')+pret.texte+' '+pret.d.editUrl};
          if(pret.fichier && navigator.canShare && navigator.canShare({files:[pret.fichier]})) data.files=[pret.fichier];
          else data.url=pret.d.editUrl;
          if(navigator.share) navigator.share(data).catch(function(){});
          else if(navigator.clipboard) navigator.clipboard.writeText(pret.d.editUrl).then(function(){ cptOut.textContent=envoi.getAttribute('data-copie'); });
        });
        document.getElementById('hcat-cpt-env-copie').addEventListener('click',function(){
          if(!pret){ cptOut.textContent=envoi.getAttribute('data-prep'); return; }
          if(navigator.clipboard) navigator.clipboard.writeText(pret.d.editUrl).then(function(){ cptOut.textContent=envoi.getAttribute('data-copie'); },function(){ cptOut.textContent=pret.d.editUrl; });
          else cptOut.textContent=pret.d.editUrl;
        });
      }
    }

    /* 17/09/2026. Mode vendeur. « Nouveau devis client » repart d'une page vierge (avec la
       confirmation portee par « Vider »), puis propose de commencer sans client ou de
       renseigner le client tout de suite. La fiche ecrit dans les MEMES champs que le
       formulaire de commande : aucune seconde copie des coordonnees. */
    (function(){
      var nouveau=document.getElementById('hcat-vendeur-nouveau');
      if(!nouveau || !VENDEUR) return;
      var choix=document.getElementById('hcat-vendeur-choix'), fiche=document.getElementById('hcat-vendeur-fiche'),
          pour=document.getElementById('hcat-vendeur-pour'), adrTxt=document.getElementById('hcat-vf-adr');
      var siege=null;
      /* 22/09/2026, Charles : « quand je clique sur facture proforma ca me met merci
         d'indiquer votre adresse de facturation, mais je vois pas ou remplir ». La fiche ne
         portait AUCUN champ d'adresse : l'adresse n'arrivait que si l'on choisissait la
         societe dans les suggestions de l'annuaire. Une societe tapee a la main, etrangere,
         ou un independant restaient sans adresse, et la proforma etait refusee. Les champs
         sont construits ici avec les libelles, deja traduits, des champs de facturation :
         aucune chaine nouvelle, et le gabarit n'est pas touche. */
      var apresFiche=null, vfAdr={};
      ['adr','cp','ville'].forEach(function(k){
        var modele=document.getElementById('hcat-cl-'+k);
        var el=document.createElement('input');
        el.type='text'; el.id='hcat-vf-'+(k==='adr'?'rue':k); el.autocomplete='off';
        el.placeholder=modele ? modele.placeholder : '';
        adrTxt.parentNode.insertBefore(el, adrTxt);
        vfAdr[k]=el;
      });
      adrTxt.hidden=true;
      var majPour=function(){
        var soc=(client.soc||'').trim();
        pour.hidden=false;
        pour.textContent = soc ? pour.getAttribute('data-pour')+' '+soc : pour.getAttribute('data-sans');
      };
      /* 17/09/2026, Charles : « ca fait beaucoup de boutons ». Le choix du client est une
         ETAPE, dans sa fenetre : etape 1 le choix, etape 2 la fiche. Le bandeau ne porte
         plus que deux boutons. */
      var fenN=document.getElementById('hcat-nouveau'),
          titreN=document.getElementById('hcat-nouveau-titre'), sousN=document.getElementById('hcat-nouveau-sous');
      var etapeN=function(n){
        choix.hidden = n!==1; fiche.hidden = n!==2;
        if(titreN) titreN.textContent=titreN.getAttribute('data-e'+n)||titreN.textContent;
        if(sousN) sousN.textContent=sousN.getAttribute('data-e'+n)||sousN.textContent;
      };
      var fermerNouveau=function(){
        apresFiche=null;
        if(fenN) fenN.classList.remove('is-open');
        document.documentElement.classList.remove('hcat-fige');
      };
      var ouvrirNouveau=function(n){
        etapeN(n);
        if(fenN){ fenN.classList.add('is-open'); document.documentElement.classList.add('hcat-fige'); }
      };
      var ouvrirFiche=function(){
        ['soc','nom','em','tel','tva'].forEach(function(k){ var el=document.getElementById('hcat-vf-'+k); if(el) el.value=client[k]||''; });
        adrTxt.textContent=[client.adr,client.cp,client.ville].filter(Boolean).join(' · ');
        vfAdr.adr.value=client.adr||''; vfAdr.cp.value=client.cp||''; vfAdr.ville.value=client.ville||'';
        ouvrirNouveau(2);
        setTimeout(function(){ var s=document.getElementById('hcat-vf-soc'); if(s) s.focus(); },60);
      };
      var versCatalogue=function(){ var cat=document.getElementById('hcat-catalogue'); if(cat) cat.scrollIntoView({behavior:'smooth'}); };
      nouveau.addEventListener('click',function(){
        var rb=document.getElementById('hcat-reset');
        if((state.lines.length || (client.soc||'').trim() || (client.em||'').trim()) && rb) rb.click();
        if(state.lines.length || (client.soc||'').trim() || (client.em||'').trim()) return;
        siege=null; pour.hidden=true; ouvrirNouveau(1);
      });
      if(fenN){
        document.getElementById('hcat-nouveau-close').addEventListener('click',fermerNouveau);
        document.getElementById('hcat-nouveau-retour').addEventListener('click',function(){ etapeN(1); });
        surFond(fenN,function(){ fermerNouveau(); });
        document.addEventListener('keydown',function(e){
          if(e.key!=='Escape' || !fenN.classList.contains('is-open')) return;
          var sg=document.getElementById('hcat-vf-suggest');
          if(sg && !sg.hidden){ sg.hidden=true; return; }
          fermerNouveau();
        });
      }
      var encours=document.getElementById('hcat-vendeur-encours');
      var fen=document.getElementById('hcat-encours');
      var fermerEncours=function(){ if(fen) fen.classList.remove('is-open'); document.documentElement.classList.remove('hcat-fige'); };
      if(fen){
        document.getElementById('hcat-encours-close').addEventListener('click',fermerEncours);
        surFond(fen,function(){ fermerEncours(); });
        document.addEventListener('keydown',function(e){ if(e.key==='Escape') fermerEncours(); });
      }
      /* La liste est prechargee des l'ouverture de la page : la fenetre s'affiche pleine,
         puis la liste suivante se prepare en arriere-plan. */
      /* 15/10/2026, Charles : « laisser tout l'historique des devis si jamais on veut
         reprendre les anciens ». Rien n'etait perdu : un devis archive restait retrouvable
         par societe, nom, email ou numero. Ce qui manquait, c'etait de les PARCOURIR sans
         connaitre de nom. Le bouton n'agit donc que sur la liste, pas sur la recherche. */
      var avecArchives=false;
      var precharger=function(){
        return fetch(DEVIS_API+'-recherche',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({q:'*',vendeur:VENDEUR,arch:avecArchives})})
          .then(function(r){ return r.json(); });
      };
      var prochaine = fen ? precharger() : null;
      if(prochaine) prochaine.catch(function(){});
      var afficherListe=function(q, promesse){
        var liste=document.getElementById('hcat-encours-liste');
        liste.innerHTML='';
        chercherClient(q, document.getElementById('hcat-resume-msg'),
          {boite:liste, info:document.getElementById('hcat-encours-msg'), charge:fen.getAttribute('data-charge'), apres:fermerEncours,
           promesse:promesse || null, archivable:true, arch:avecArchives,
           surArchive:function(annule){
             prochaine=precharger(); prochaine.catch(function(){});
             if(annule) afficherListe(rech && rech.value.trim().length>=2 ? rech.value.trim() : '*', rech && rech.value.trim().length>=2 ? null : prochaine);
           }});
      };
      /* 17/09/2026, Charles : « une petite barre de recherche, pour un devis plus lointain
         que les 30 derniers ». Elle cherche dans TOUS les devis ; vide, la liste revient. */
      var rech=document.getElementById('hcat-encours-rech'), minuterieR=null;
      if(rech) rech.addEventListener('input',function(){
        clearTimeout(minuterieR);
        minuterieR=setTimeout(function(){
          var q=rech.value.trim();
          if(q.length>=2) afficherListe(q, null);
          else if(!q) afficherListe('*', prochaine);
        },350);
      });

      /* Le bouton des archives, a cote de la barre de recherche. Construit ici et non dans
         le gabarit pour la meme raison que les champs du Comptoir : catalogue-pro-part1
         est a 1,7 Ko du plafond de 50 Ko impose par Shopify sur un reglage Liquid.
         Il ne change QUE la liste : une recherche nommee a toujours rendu les archives. */
      (function construireArchives(){
        if(!VENDEUR || !rech || !rech.parentNode || document.getElementById('hcat-encours-arch')) return;
        var A=ARCHIVES_LIBELLES.split('|');
        var b=document.createElement('button');
        b.type='button'; b.className='hcat-cpt-btn2'; b.id='hcat-encours-arch';
        b.textContent=A[0];
        rech.parentNode.insertBefore(b, rech.nextSibling);
        b.addEventListener('click',function(){
          avecArchives=!avecArchives;
          b.textContent=avecArchives?A[1]:A[0];
          prochaine=precharger(); prochaine.catch(function(){});
          var q=rech.value.trim();
          afficherListe(q.length>=2?q:'*', q.length>=2?null:prochaine);
        });
      })();
      if(encours && fen) encours.addEventListener('click',function(){
        fen.classList.add('is-open'); document.documentElement.classList.add('hcat-fige');
        if(rech) rech.value='';
        var celle=prochaine;
        afficherListe('*', celle ? celle.catch(function(){ return precharger(); }) : null);
        prochaine=precharger(); prochaine.catch(function(){});
      });
      document.getElementById('hcat-vendeur-anonyme').addEventListener('click',function(){ fermerNouveau(); majPour(); versCatalogue(); });
      document.getElementById('hcat-vendeur-fiche-btn').addEventListener('click',ouvrirFiche);
      pour.addEventListener('click',ouvrirFiche);
      brancherAnnuaire(document.getElementById('hcat-vf-soc'), document.getElementById('hcat-vf-suggest'), function(e){
        document.getElementById('hcat-vf-soc').value=e.nom;
        document.getElementById('hcat-vf-tva').value=e.tva;
        siege=e; adrTxt.textContent=[e.adresse,e.cp,e.ville].filter(Boolean).join(' · ');
        vfAdr.adr.value=e.adresse||''; vfAdr.cp.value=e.cp||''; vfAdr.ville.value=e.ville||'';
      });
      document.getElementById('hcat-vf-ok').addEventListener('click',function(){
        ['soc','nom','em','tel','tva'].forEach(function(k){ poserChamp('hcat-cl-'+k,(document.getElementById('hcat-vf-'+k).value||'').trim()); });
        /* L'adresse vient desormais des champs de la fiche : preremplis par l'annuaire,
           mais saisis a la main quand la societe n'y figure pas. */
        poserChamp('hcat-cl-adr',vfAdr.adr.value.trim()); poserChamp('hcat-cl-cp',vfAdr.cp.value.trim()); poserChamp('hcat-cl-ville',vfAdr.ville.value.trim());
        if(siege) choisirPaysFR();
        var suite=apresFiche;
        fermerNouveau(); majPour();
        if(suite) suite(); else versCatalogue();
      });
      majBandeauVendeur=function(){ if((client.soc||'').trim() || !pour.hidden) majPour(); };
      /* La proforma du Comptoir ouvre la fiche au lieu de designer un champ hors de vue,
         et reprend toute seule une fois la fiche validee. */
      ouvrirFicheAdresse=function(suite){
        ouvrirFiche();
        apresFiche=suite||null;
        var champs=[document.getElementById('hcat-vf-em'), vfAdr.adr, vfAdr.cp, vfAdr.ville];
        var vide=champs.filter(function(x){ return x && !(x.value||'').trim(); })[0];
        setTimeout(function(){ (vide||vfAdr.adr).focus(); },90);
      };
      if((client.soc||'').trim()) majPour();
    })();

    /* 17/09/2026, phase 6. Le lien « projet sur mesure » emmene le devis en cours
       jusqu'au formulaire, qui le depose dans son champ « body ». Le guichet le lit
       alors sous le nom « Corps » et repond PROJET_ACCUSE, le texte valide qui parle
       d'une SELECTION, au lieu de l'accuse generique.
       Le lien est du Liquid statique : il ne peut pas connaitre le devis. On l'ajoute
       donc au clic, et seulement s'il existe : sans devis, rien ne change. */
    Array.prototype.forEach.call(document.querySelectorAll('a.hcat-cta'), function(a){
      a.addEventListener('click', function(){
        if(!curDevis || !curDevis.num) return;
        var h = a.getAttribute('href') || '';
        if(h.indexOf('devis=') !== -1) return;
        var frag = h.indexOf('#');
        var base = frag === -1 ? h : h.slice(0, frag);
        var ancre = frag === -1 ? '' : h.slice(frag);
        a.setAttribute('href', base + (base.indexOf('?') === -1 ? '?' : '&')
                       + 'devis=' + encodeURIComponent(curDevis.num) + ancre);
      });
    });

    /* 17/09/2026. « Voir ma selection » : ce qui est dans le devis, modifiable sur place,
       sans re-defiler le catalogue. Chaque + et - CLIQUE le bouton de la carte elle-meme :
       aucune seconde logique de quantite, donc rien qui puisse diverger de la barre. */
    var selModal=document.getElementById('hcat-sel');
    function lignesSelection(){
      var out=[];
      cards.forEach(function(card){
        if(card.getAttribute('data-kind')==='multi'){
          var sel=card.querySelector('.hcat-size'), q=card._qty||{};
          Array.prototype.forEach.call(sel.options,function(o){
            if((q[o.value]||0)>0) out.push({card:card,opt:o.value,name:card.getAttribute('data-name'),size:o.text,qty:q[o.value]});
          });
        } else {
          var v=parseInt(card.querySelector('.hcat-qty').value,10)||0;
          if(v>0) out.push({card:card,opt:null,name:card.getAttribute('data-name'),size:card.getAttribute('data-size')||'',qty:v});
        }
      });
      return out;
    }
    function toucher(l,sens){
      if(l.opt!==null){
        var sel=l.card.querySelector('.hcat-size');
        if(sel.value!==l.opt){ sel.value=l.opt; sel.dispatchEvent(new Event('change',{bubbles:true})); }
      }
      l.card.querySelector(sens>0?'.hcat-plus':'.hcat-minus').click();
      renderSelection();
    }
    function renderSelection(){
      if(!selModal) return;
      var box=document.getElementById('hcat-sel-lines'); box.innerHTML='';
      var ls=lignesSelection();
      document.getElementById('hcat-sel-total').textContent=document.querySelector('#hcat-bar .hcat-bar-count').textContent+' · '+document.querySelector('#hcat-bar .hcat-bar-pro').textContent;
      var lc=document.getElementById('hcat-sel-client');
      if(lc && !lc.hidden){
        var socC=(client.soc||'').trim();
        lc.textContent = socC ? lc.getAttribute('data-pour')+' '+socC+' · '+lc.getAttribute('data-modifier') : lc.getAttribute('data-aucun');
      }
      /* 17/09/2026 (repasse) : TTC additionne tel quel (130,00 et non 130,01). */
      var ttc=state.pubTtc||Math.round(state.pub*(1+VAT));
      document.getElementById('hcat-sel-pub').textContent=euro(ttc);
      /* Le prix pro exclut l'ignifugation, montree sur sa propre ligne : sinon il depassait
         le prix public barre. */
      document.getElementById('hcat-sel-pro').textContent=euro(state.total-state.ship-state.ignifTotal-(state.prestaTotal||0));
      var il=document.getElementById('hcat-sel-ignifl');
      if(il){ if(state.ignifTotal>0){ document.getElementById('hcat-sel-ignif').textContent=euro(state.ignifTotal); il.hidden=false; } else il.hidden=true; }
      /* Acompte : pourcentage de la marchandise, le solde restant du avant expedition. */
      var acl=document.getElementById('hcat-sel-acl'), sol=document.getElementById('hcat-sel-soldel');
      if(acl && sol){
        var marchandise=state.total-state.ship;
        if(acompte>0 && marchandise>0){
          var duNow=Math.round(marchandise*acompte/100);
          document.getElementById('hcat-sel-ac-t').textContent=libelleAcompte()+' ('+acompte+' %)';
          document.getElementById('hcat-sel-ac').textContent=euro(duNow);
          document.getElementById('hcat-sel-solde').textContent=euro(marchandise-duNow+state.ship);
          acl.hidden=false; sol.hidden=false;
        } else { acl.hidden=true; sol.hidden=true; }
      }
      var rl=document.getElementById('hcat-sel-remisel'), ap=document.getElementById('hcat-sel-apres');
      if(rl && ap){
        if(state.codeRemise>0){
          document.getElementById('hcat-sel-remise-t').textContent=libelleRemise();
          document.getElementById('hcat-sel-remise').textContent='−'+euro(state.codeRemise);
          /* 15/10/2026 : cette ligne REECRIT le prix pro calcule plus haut, pour le montrer
             avant remise. Elle avait ete oubliee quand la prestation est arrivee le 14/10 :
             des qu'un code ou un geste s'appliquait, la prestation retombait dans le prix
             pro et le faisait depasser le prix public barre. Meme base que plus haut. */
          document.getElementById('hcat-sel-pro').textContent=euro(state.total-state.ship-state.ignifTotal-(state.prestaTotal||0)+state.codeRemise);
          document.getElementById('hcat-sel-apres-v').textContent=euro(state.total-state.ship);
          rl.hidden=false; ap.hidden=false;
        } else { rl.hidden=true; ap.hidden=true; }
      }
      var portl=document.getElementById('hcat-sel-portl');
      var portT=document.getElementById('hcat-sel-port-t');
      if(portT && !portT.getAttribute('data-estime')) portT.setAttribute('data-estime', portT.textContent);
      if(portOffert && state.items>0){ if(portT) portT.textContent=libelleOfferte(); document.getElementById('hcat-sel-port').textContent=euro(0); portl.hidden=false; }
      else if(state.ship>0){ if(portT) portT.textContent=portT.getAttribute('data-estime'); document.getElementById('hcat-sel-port').textContent=euro(state.ship); portl.hidden=false; } else { portl.hidden=true; }
      document.getElementById('hcat-sel-eco').textContent=euro(state.pub-state.pro+state.codeRemise);
      if(!ls.length){ var p=document.createElement('p'); p.className='hcat-sel-vide'; p.textContent=selModal.getAttribute('data-vide'); box.appendChild(p); return; }
      ls.forEach(function(l){
        var row=document.createElement('div'); row.className='hcat-sel-row';
        var nom=document.createElement('button'); nom.type='button'; nom.className='hcat-sel-nom';
        nom.title=selModal.getAttribute('data-voir');
        nom.textContent=l.name+(l.size?' · '+l.size:'');
        nom.addEventListener('click',function(){ if(selModal._defiler) selModal._defiler(l.card); else { selModal.classList.remove('is-open'); l.card.scrollIntoView({behavior:'smooth',block:'center'}); } });
        var qte=document.createElement('div'); qte.className='hcat-sel-qte';
        var moins=document.createElement('button'); moins.type='button'; moins.textContent='−'; moins.addEventListener('click',function(){ toucher(l,-1); });
        var val=document.createElement('span'); val.textContent=l.qty;
        var plus=document.createElement('button'); plus.type='button'; plus.textContent='+'; plus.addEventListener('click',function(){ toucher(l,1); });
        qte.appendChild(moins); qte.appendChild(val); qte.appendChild(plus);
        row.appendChild(nom); row.appendChild(qte); box.appendChild(row);
      });
    }
    /* 17/09/2026, soir. La pastille ouvre le volet « Mon devis » : lignes, options,
       prix public TTC puis prix pro HT. Il se ferme par la croix, par le fond, ou par le
       geste retour du telephone (une entree d'historique est posee a l'ouverture). */
    var voirBtn=document.getElementById('hcat-voir');
    if(voirBtn && selModal){
      var opts=document.getElementById('hcat-options'), boiteOpts=document.getElementById('hcat-sel-opts');
      if(opts && boiteOpts) boiteOpts.appendChild(opts);
      /* 17/09/2026, Charles connecte en cs@ : « j'aimerais avoir les autres options ici ».
         Pour les deux associes, le Comptoir (geste, livraison offerte, lien carte, proforma,
         envoi du devis) vit dans le volet, juste avant « Finaliser ». Ses messages, ecrits
         dans la fenetre de commande, sont recopies dans sa zone de sortie. */
      var cptBoite=document.getElementById('hcat-cpt'), boutonFin=document.getElementById('hcat-open');
      if(VENDEUR && cptBoite && boutonFin && CFG.comptoir){
        boutonFin.parentNode.insertBefore(cptBoite, boutonFin);
        var confM=document.getElementById('hcat-m-confirm'), sortieC=document.getElementById('hcat-cpt-out');
        if(confM && sortieC && window.MutationObserver){
          new MutationObserver(function(){
            if(!selModal.classList.contains('is-open') || !confM.innerHTML) return;
            if(!(client.em||'').trim()) sortieC.textContent=cptBoite.getAttribute('data-sans-client');
            else sortieC.innerHTML=confM.innerHTML;
          }).observe(confM,{childList:true,subtree:true,characterData:true});
        }
        var viderSel=document.getElementById('hcat-vider-sel'), nouveauD=document.getElementById('hcat-nouveau-devis'), viderTout=document.getElementById('hcat-reset');
        if(viderSel && nouveauD && viderTout){
          viderTout.hidden=true; viderSel.hidden=false; nouveauD.hidden=false;
          viderSel.addEventListener('click',function(){
            if(!window.confirm(viderSel.getAttribute('data-confirmer'))) return;
            resetAll(); recalc(); persist(); renderSelection();
            fermerVolet(false);
          });
          nouveauD.addEventListener('click',function(){
            fermerVolet(false);
            var nb=document.getElementById('hcat-vendeur-nouveau');
            if(nb) setTimeout(function(){ nb.click(); },120);
          });
        }
        var ligneClient=document.getElementById('hcat-sel-client');
        if(ligneClient){
          ligneClient.hidden=false;
          ligneClient.addEventListener('click',function(){
            fermerVolet(false);
            var fb=document.getElementById('hcat-vendeur-fiche-btn');
            setTimeout(function(){ if(fb) fb.click(); },120);
          });
        }
      }
      var aDefiler=null;
      var ouvrirVolet=function(){
        renderSelection(); selModal.classList.add('is-open');
        document.documentElement.classList.add('hcat-fige');
        try{ history.pushState({hcatVolet:1},''); }catch(e){}
      };
      var fermerVolet=function(parHistorique){
        if(!selModal.classList.contains('is-open')) return;
        selModal.classList.remove('is-open');
        document.documentElement.classList.remove('hcat-fige');
        if(!parHistorique && history.state && history.state.hcatVolet){ try{ history.back(); return; }catch(e){} }
        if(aDefiler){ var c=aDefiler; aDefiler=null; setTimeout(function(){ c.scrollIntoView({behavior:'smooth',block:'center'}); },60); }
      };
      window.addEventListener('popstate',function(){
        if(selModal.classList.contains('is-open')) fermerVolet(true);
        else if(aDefiler){ var c=aDefiler; aDefiler=null; setTimeout(function(){ c.scrollIntoView({behavior:'smooth',block:'center'}); },60); }
      });
      voirBtn.addEventListener('click',function(){ if(typeof proposerMot==='function') proposerMot(); ouvrirVolet(); });
      document.getElementById('hcat-sel-close').addEventListener('click',function(){ fermerVolet(false); });
      surFond(selModal,function(){ fermerVolet(false); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape') fermerVolet(false); });
      document.getElementById('hcat-open').addEventListener('click',function(){ if(state.lines.length) fermerVolet(false); });
      selModal._defiler=function(card){ aDefiler=card; fermerVolet(false); };
      /* Le volet suit chaque recalcul (options, code, port qui arrive du serveur). */
      new MutationObserver(function(){ if(selModal.classList.contains('is-open')) renderSelection(); })
        .observe(bar,{childList:true,characterData:true,subtree:true});
    }

    /* 17/09/2026. Animations d'apparition, dans l'esprit de la page Decouvrir, et pastilles
       de categories. Rien n'est masque sans script : c'est le script qui pose l'etat de
       depart. Un telephone regle sur « reduire les animations » voit tout, tout de suite. */
    (function(){
      var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cibles = Array.prototype.slice.call(root.querySelectorAll('[data-hcat-rv], .hcat-card'));
      if(calme || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, {rootMargin:'0px 0px -6% 0px', threshold:0.08});
      cibles.forEach(function(el, i){
        el.classList.add('hcat-rv');
        if(el.classList.contains('hcat-card')) el.style.transitionDelay = ((i % 4) * 70) + 'ms';
        io.observe(el);
      });
    })();
    (function(){
      var chips = Array.prototype.slice.call(root.querySelectorAll('.hcat-chips a'));
      chips.forEach(function(a){
        a.addEventListener('click', function(ev){
          var cible = document.querySelector(a.getAttribute('href'));
          if(!cible) return;
          ev.preventDefault();
          chips.forEach(function(x){ x.classList.remove('is-on'); }); a.classList.add('is-on');
          /* 17/09/2026 (repasse) : 150 px ne suffisaient pas sur ordinateur, le titre passait
             sous la barre collante. On mesure l'en-tete du theme et les pastilles. */
          var barreEl = document.querySelector('.hcat-chips');
          var entete = barreEl ? (parseFloat(getComputedStyle(barreEl).top) || 0) : 0;
          var barre = barreEl ? barreEl.offsetHeight : 60;
          var y = cible.getBoundingClientRect().top + window.scrollY - entete - barre - 36;
          window.scrollTo({top:y, behavior:'smooth'});
        });
      });
    })();
    /* Un petit battement sur la barre a chaque changement : on voit que le total a bouge. */
    (function(){
      var b = document.getElementById('hcat-bar'); if(!b) return;
      var total = b.querySelector('.hcat-bar-pro'); if(!total || !window.MutationObserver) return;
      new MutationObserver(function(){ total.classList.remove('hcat-pulse'); void total.offsetWidth; total.classList.add('hcat-pulse'); })
        .observe(total, {childList:true, characterData:true, subtree:true});
    })();

    var dlBtn=document.getElementById('hcat-download');
    dlBtn.addEventListener('click',function(){
      if(!state.lines.length) return;
      /* 09/09/2026 : si la librairie PDF n'etait pas encore chargee, le bouton
         retournait EN SILENCE. Sur mobile, avec une connexion lente, on appuyait et
         il ne se passait strictement rien. */
      if(!window.jspdf){ attendrePdf(this); return; }
      dlBtn.disabled=true; dlBtn.textContent='Wird erzeugt...';
      ensureDevis(function(d){
        buildPdf(d.num, d.now, d.editUrl);
        dlBtn.disabled=false; dlBtn.textContent='Angebot als PDF herunterladen';
      });
    });

    /* Laisse au navigateur le temps de charger jsPDF, en le disant, puis reessaie. */
    function attendrePdf(btn){
      var conf=document.getElementById('hcat-m-confirm');
      if(conf){ conf.innerHTML='Das Dokument wird vorbereitet, einen Augenblick…'; conf.classList.add('is-on'); }
      var essais=0;
      var t=setInterval(function(){
        essais++;
        if(window.jspdf){
          clearInterval(t);
          if(conf){ conf.innerHTML=''; conf.classList.remove('is-on'); }
          if(btn) btn.click();
        } else if(essais>=20){
          clearInterval(t);
          if(conf){ conf.innerHTML='Das Dokument lässt sich auf diesem Gerät nicht erstellen. Schreiben Sie an pro@hopercollection.com, nous vous l\'envoyons.'; conf.classList.add('is-on'); }
        }
      }, 250);
    }

    var mBtn=document.getElementById('hcat-mailbtn');
    var mLabel='✉️ Dieses Angebot per E-Mail senden';
    /* 17/09/2026, Comptoir tranche 3. Le Comptoir envoie le MEME devis, avec un autre
       texte : DEVIS_ENVOI au lieu de DEVIS_COPIE, tous deux valides le 16/09. Recopier
       ce chemin pour lui en aurait fait une seconde version, et la seconde version d'une
       regle diverge toujours de la premiere. On l'extrait donc en fonction, et l'ORIGINE
       est le seul parametre qui change. */
    function envoyerDevis(btn, origine, label){
      if(!state.lines.length) return;
      /* 09/09/2026 : si la librairie PDF n'etait pas encore chargee, le bouton
         retournait EN SILENCE. Sur mobile, avec une connexion lente, on appuyait et
         il ne se passait strictement rien. */
      if(!window.jspdf){ attendrePdf(btn); return; }
      if(!(client.em||'').trim()){ needField('hcat-cl-em','Tragen Sie oben Ihre <b>E-Mail-Adresse</b> ein: dorthin geht Ihr Angebot als PDF.'); return; }
      btn.disabled=true; btn.textContent='Envoi en cours...';
      ensureDevis(function(d){
        var fail=function(msg){
          btn.disabled=false; btn.textContent=label;
          var conf=document.getElementById('hcat-m-confirm');
          conf.innerHTML=msg; conf.classList.add('is-on');
        };
        try{
          var doc=buildPdf(d.num, d.now, d.editUrl, true);
          var b64=doc.output('datauristring'); b64=b64.slice(b64.indexOf(',')+1);
          fetch(MAIL_API,{method:'POST',headers:{'Content-Type':'application/json'},
                /* 17/09/2026 : la LANGUE part avec la demande. Sans elle, un client
                   anglophone recevait un email en francais, parce que le serveur n'avait
                   aucun moyen de savoir dans quelle langue il lisait. Elle vient du
                   DOCUMENT, comme partout ailleurs dans ce moteur, jamais d'une variable
                   Liquid : le marche EN n'existe pas cote Shopify. */
                body:JSON.stringify({num:d.num,email:(client.em||'').trim(),url:d.editUrl,pdf:b64,
                  origine:origine, vendeur:(origine==='comptoir'&&VENDEUR)?VENDEUR:undefined, mot:(origine==='comptoir'&&motClient)?motClient:undefined,
                  lang:((document.documentElement.lang||'').toLowerCase().indexOf('en')===0?'en':'fr')})})
            .then(function(r){ return r.json(); })
            .then(function(res){
              if(res && res.ok){
                btn.disabled=false; btn.textContent=label;
                var conf=document.getElementById('hcat-m-confirm');
                conf.innerHTML='Es ist versandt! ✅<br>Ihr Angebot '+d.num+' (PDF im Anhang) erreicht <b>'+(client.em||'').trim()+'</b> in wenigen Minuten.';
                conf.classList.add('is-on');
              } else fail('Der Versand ist im Moment nicht möglich. Laden Sie das PDF herunter oder versuchen Sie es gleich erneut.');
            })
            .catch(function(){ fail('Keine Verbindung. Laden Sie das PDF herunter oder versuchen Sie es gleich erneut.'); });
        }catch(e){ fail('Der Versand ist im Moment nicht möglich. Laden Sie das PDF herunter oder versuchen Sie es gleich erneut.'); }
      });
    }
    mBtn.addEventListener('click',function(){ envoyerDevis(mBtn,'client',mLabel); });

    /* --- commande self-service : carte ou facture/virement --- */
    function doCheckout(mode, btn, opts){
      opts = opts || {};
      if(!state.lines.length) return;
      /* 15/10/2026 : la prestation a d'abord interdit le paiement en ligne, parce que le
         controle de prix du worker comparait un total qui la contenait a un brouillon qui
         ne la contenait pas, et tombait sur « les tarifs ont change ». Le worker la pose
         maintenant en ligne de commande, comme l'ignifugation : un devis avec prestation
         se paie par carte comme les autres. Ne pas remettre de garde ici sans remettre la
         prestation des deux cotes du controle. */
      if(!(client.em||'').trim()){
        /* 22/09/2026, repasse : le serveur exige l'email pour la carte AUSSI (« email_manquant »).
           Au Comptoir, ce message s'ecrivait dans le volet d'estimation, ferme : le lien
           carte restait sans reponse. La fiche s'ouvre donc pour les deux modes. */
        if(opts.comptoir && ouvrirFicheAdresse){ ouvrirFicheAdresse(function(){ doCheckout(mode, btn, opts); }); return; }
        var conf=document.getElementById('hcat-m-confirm');
        conf.innerHTML='Tragen Sie oben Ihre <b>E-Mail-Adresse</b> ein, um zu erhalten '+(mode==='cb'?'den Zahlungslink.':'Ihre Rechnung.');
        conf.classList.add('is-on');
        var emEl=document.getElementById('hcat-cl-em'); if(emEl) emEl.focus();
        return;
      }
      if(mode==='virement' && !((client.adr||'').trim() && (client.cp||'').trim() && (client.ville||'').trim())){
        if(opts.comptoir && ouvrirFicheAdresse){ ouvrirFicheAdresse(function(){ doCheckout(mode, btn, opts); }); return; }
        var confA=document.getElementById('hcat-m-confirm');
        confA.innerHTML='Um Ihre Proformarechnung zu erstellen, geben Sie bitte Ihre <b>Rechnungsadresse</b> an.';
        confA.classList.add('is-on');
        showStep(1);
        var adEl=document.getElementById('hcat-cl-adr'); if(adEl) adEl.focus();
        return;
      }
      var label=btn.textContent;
      btn.disabled=true; btn.textContent='Einen Augenblick...';
      ensureDevis(function(d){
        var go=function(){
        fetch(CHECKOUT_API,{method:'POST',headers:{'Content-Type':'application/json'},
              body:JSON.stringify({num:d.num,mode:mode,vendeur:(opts.comptoir&&VENDEUR)?VENDEUR:undefined})})
          .then(function(r){ return r.json(); })
          .then(function(res){
            btn.disabled=false; btn.textContent=label;
            var conf=document.getElementById('hcat-m-confirm');
            if(res && res.ok){
              /* 17/09/2026. Depuis le Comptoir, le lien est pour le CLIENT : on l'affiche a
                 l'associe au lieu d'emmener son propre navigateur sur la page de paiement. */
              if(mode==='cb' && res.pay_url && opts.onLien){ opts.onLien(res.pay_url, d); return; }
              if(mode==='cb' && res.pay_url){
                conf.innerHTML='Weiterleitung zur sicheren Zahlung...';
                conf.classList.add('is-on');
                window.location.href=res.pay_url;
                return;
              }
              conf.innerHTML = mode==='cb'
                ? 'Gespeichert! ✅<br>Sie erhalten per E-Mail Ihren <b>sicheren Zahlungslink</b> (Angebot '+d.num+').<br>Ihre Bestellung geht in die Vorbereitung, sobald die Zahlung eingeht.'
                : 'Gespeichert! ✅<br>Ihre <b>Proformarechnung</b> (Angebot '+d.num+') erreicht Sie in wenigen Minuten per E-Mail, zahlbar per Überweisung.<br>Die endgültige Rechnung folgt nach Eingang der Zahlung, und Ihre Bestellung geht in die Vorbereitung.';
            } else {
              /* 09/09/2026 : toutes les raisons de refus du serveur etaient dites avec
                 la MEME phrase, qui ne dit rien et n'indique aucun geste a faire. Le
                 client repartait sans savoir ce qui manquait. */
              var motifs = {
                adresse_manquante: 'Ihre <b>Lieferadresse</b> fehlt: Straße und Hausnummer, Postleitzahl und Ort. Ergänzen Sie sie oben und bestätigen Sie erneut.',
                pays_inconnu: 'Das <b>Lieferland</b> wird nicht erkannt. Wählen Sie es aus der Liste und bestätigen Sie erneut.',
                port_indisponible: 'Dieses Ziel beliefern wir noch nicht. Schreiben Sie an <b>pro@hopercollection.com</b>, wir organisieren den Transport mit Ihnen.',
                poids_inconnu: 'Eines der gewählten Stücke ist noch nicht für den Online-Verkauf bereit. Schreiben Sie an <b>pro@hopercollection.com</b>, wir kalkulieren es für Sie.',
                prix_perime: 'Die Preise haben sich seit der Zusammenstellung Ihres Angebots geändert. Laden Sie die Seite neu, Ihre Auswahl bleibt erhalten.',
                ignif_hors_france: 'Die <b>Flammschutzbehandlung</b> gilt nur für Lieferungen in Frankreich: unsere Werkstatt ist französisch. Nehmen Sie das Häkchen weg, oder schreiben Sie an <b>pro@hopercollection.com</b>, damit wir die Behandlung vor Ort organisieren.',
                ignif_incoherent: 'Der Betrag der Flammschutzbehandlung stimmt nicht mehr mit dem Angebot überein. Laden Sie die Seite neu und bestätigen Sie erneut.',
                devis_sans_total: 'Ihre Auswahl scheint leer zu sein. Fügen Sie mindestens ein Stück hinzu und bestätigen Sie erneut.',
                devis_verrouille: 'Dieses Angebot wurde vor mehr als dreißig Minuten bestätigt und kann nicht mehr geändert werden. Stellen Sie es neu zusammen, oder schreiben Sie an <b>pro@hopercollection.com</b>.',
                retrait_indisponible: 'Die Abholung vor Ort wird im Moment nicht angeboten. Wählen Sie die Lieferung.',
                traitement_en_cours: 'Ihre Bestellung wird bereits angelegt, einen Augenblick.',
                tva_verification: 'Die Prüfung Ihrer <b>europäischen USt-IdNr.</b> ist momentan nicht verfügbar. Versuchen Sie es in einigen Minuten erneut, oder schreiben Sie an <b>pro@hopercollection.com</b>.',
                acompte_carte_seulement: 'Ein Angebot mit Anzahlung wird <b>per Karte</b> bezahlt: die Anzahlung wird bei der Bestellung eingezogen, der Restbetrag vor dem Versand.',
                acompte_compte_requis: 'Die Anzahlung setzt ein <b>offenes Geschäftskundenkonto</b> für diesen Kunden voraus. Eröffnen Sie eines, oder nehmen Sie die Anzahlung weg.',
                compte_pro_requis: 'Die Online-Zahlung ist offenen Geschäftskundenkonten vorbehalten. Melden Sie sich an, oder schreiben Sie an <b>pro@hopercollection.com</b>.',
                draft_ko: 'Ihre Bestellung konnte nicht angelegt werden. Versuchen Sie es gleich erneut, oder schreiben Sie an <b>pro@hopercollection.com</b>.',
                vendeur_refuse: 'Ihre Verkäufersitzung ist abgelaufen. Laden Sie die Seite neu, Ihre Auswahl bleibt erhalten.',
                devis_paye: 'Dieses Angebot ist bereits bezahlt. Schreiben Sie an <b>pro@hopercollection.com</b>, wenn Sie erneut bestellen möchten.',
                quota: 'Wir erhalten im Moment sehr viele Bestellungen. Versuchen Sie es in einigen Minuten erneut, oder schreiben Sie an <b>pro@hopercollection.com</b>.'
              };
              var motif = (res && res.reason) ? motifs[res.reason] : null;
              /* Une commande est deja engagee sur ce devis. Le message nomme ce qui a ete
                 envoye et quand : une proforma n'est pas un lien de paiement, et annoncer
                 l'un pour l'autre ferait chercher au client un document qui n'existe pas. */
              if (res && res.reason === 'devis_engage') {
                var qd = res.engage_le ? new Date(res.engage_le) : null;
                var quand = (qd && !isNaN(qd.getTime()))
                  ? (('0' + qd.getDate()).slice(-2) + '/' + ('0' + (qd.getMonth() + 1)).slice(-2))
                  : '';
                /* Phrases ENTIERES, pas des morceaux colles : la version anglaise est
                   produite en remplacant des chaines completes. Un message assemble bout
                   a bout aurait garde des mots francais au milieu de l'anglais. */
                var gabarit = (res.mode_engage === 'virement')
                  ? 'Für dieses Angebot läuft bereits eine Bestellung, Proformarechnung am TT.MM. versandt. Um die Zahlungsart zu ändern, schreiben Sie an <b>pro@hopercollection.com</b>.'
                  : 'Für dieses Angebot läuft bereits eine Bestellung, Zahlungslink am TT.MM. versandt. Um die Zahlungsart zu ändern, schreiben Sie an <b>pro@hopercollection.com</b>.';
                motif = quand ? gabarit.replace('TT.MM', quand) : gabarit.replace(' am TT.MM.', '');
              }
              conf.innerHTML = motif ||
                'Wir konnten diese Bestellung nicht abschließen. Schreiben Sie an <b>pro@hopercollection.com</b>, wir nehmen sie von Hand auf' +
                ((res && res.reason) ? ' (Referenz: ' + res.reason + ')' : '') + '.';
              /* Et on previent la maison : un refus etait jusqu'ici invisible. */
              try {
                fetch(CODE_API.replace('/pro/code','/pro/incident'), { method:'POST',
                  headers:{'Content-Type':'application/json'},
                  body: JSON.stringify({ num: d.num, mode: mode,
                    reason: (res && res.reason) || 'inconnu',
                    detail: (res && res.detail) || '',
                    email: (client.em||'').trim(), soc: (client.soc||'').trim() }) });
              } catch(e){}
            }
            conf.classList.add('is-on');
            /* 22/09/2026, Charles : « le bouton pour sortir la proforma a l'air inerte ».
               Tous les messages s'ecrivaient en HAUT du volet, et le bouton du Comptoir est
               en BAS : ni succes ni refus n'etaient visibles. Le resultat s'affiche
               desormais juste sous le bouton, qui garde la trace du clic. */
            if(opts.zone){
              if(res && res.ok && mode==='virement'){
                conf.innerHTML='Proforma gespeichert ✅<br>Sie geht in wenigen Minuten per E-Mail an <b>EMAIL</b>, mit den Bankdaten für die Überweisung. Sobald die Überweisung mit der Angebotsnummer eingeht, geht die endgültige Rechnung von selbst hinaus und der Auftrag geht in die Vorbereitung.'.replace('EMAIL',(client.em||'').trim());
                btn.disabled=true; btn.classList.add('is-fait'); btn.textContent='Proforma gespeichert ✓';
              }
              opts.zone.innerHTML=conf.innerHTML; opts.zone.hidden=false;
              try{ opts.zone.scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){}
            }
          })
          .catch(function(){
            btn.disabled=false; btn.textContent=label;
            var conf=document.getElementById('hcat-m-confirm');
            conf.innerHTML='Keine Verbindung. Versuchen Sie es gleich erneut oder schreiben Sie uns: <b>pro@hopercollection.com</b>';
            conf.classList.add('is-on');
            if(opts.zone){ opts.zone.innerHTML=conf.innerHTML; opts.zone.hidden=false; try{ opts.zone.scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){} }
          });
        };
        /* 16/09/2026 : cet enregistrement REECRIT un devis qui existe deja. Le numero ne
           suffit plus a l'autoriser, sinon quiconque en devine un peut changer la
           selection, les quantites ou la livraison d'un client. On envoie donc le jeton,
           que le serveur a rendu a la creation et que nous gardons dans curDevis.jeton.
           La creation, elle, reste libre : ensureDevis tire toujours un numero neuf. */
        fetch(DEVIS_API+(d.jeton?'?t='+encodeURIComponent(d.jeton):''),
              {method:'POST',headers:{'Content-Type':'application/json'},
              body:JSON.stringify({num:d.num,state:collectState(),vendeur:VENDEUR||undefined})}).then(go,go);
      });
    }
    function showStep(n){
      var s1=document.getElementById('hcat-step1'), s2=document.getElementById('hcat-step2');
      if(s1) s1.style.display = (n===1?'':'none');
      if(s2) s2.style.display = (n===2?'':'none');
    }
    var gotoPay=document.getElementById('hcat-goto-pay');
    function needField(id,msg){
      var conf=document.getElementById('hcat-m-confirm');
      conf.innerHTML=msg; conf.classList.add('is-on');
      var el=document.getElementById(id); if(el) el.focus();
    }
    if(gotoPay) gotoPay.addEventListener('click',function(){
      if(!state.lines.length) return;
      if(!(client.em||'').trim()){ needField('hcat-cl-em','Tragen Sie oben Ihre <b>E-Mail-Adresse</b> ein: dort kommt der Zahlungslink oder Ihre Rechnung an.'); return; }
      /* 09/09/2026 : chacun de ces champs manquait, et une commande a ete payee sans
         qu'on sache ou la livrer. Le transporteur, lui, exige un telephone. */
      if(!(client.tel||'').trim()){ needField('hcat-cl-tel','Geben Sie eine <b>Telefonnummer</b> an: der Spediteur braucht sie, um die Lieferung anzukündigen.'); return; }
      if(!(client.adr||'').trim()){ needField('hcat-cl-adr','Geben Sie <b>Straße und Hausnummer</b> Ihrer Rechnungsadresse an.'); return; }
      if(!(client.cp||'').trim()){ needField('hcat-cl-cp','Geben Sie die <b>Postleitzahl</b> der Rechnungsadresse an.'); return; }
      if(!(client.ville||'').trim()){ needField('hcat-cl-ville','Geben Sie den <b>Ort</b> der Rechnungsadresse an.'); return; }
      if(!livr.meme){
        if(!(livr.adr||'').trim()){ needField('hcat-lv-adr','Geben Sie <b>Straße und Hausnummer</b> der Lieferadresse an.'); return; }
        if(!(livr.cp||'').trim()){ needField('hcat-lv-cp','Geben Sie die <b>Postleitzahl</b> der Lieferadresse an.'); return; }
        if(!(livr.ville||'').trim()){ needField('hcat-lv-ville','Geben Sie den <b>Ort</b> der Lieferadresse an.'); return; }
      }
      if((client.soc||'').trim()){
        var tva=(client.tva||'').toUpperCase().replace(/[^0-9A-Z]/g,'');
        if(!tva){ needField('hcat-cl-tva','Geben Sie Ihre <b>USt-IdNr. oder Handelsregisternummer</b> an: diese Angabe ist auf Rechnungen zwischen Unternehmen vorgeschrieben.'); return; }
        var luhn=function(s){ var t=0; for(var i=s.length-1,j=0;i>=0;i--,j++){ var v=+s[i]; if(j%2===1){ v*=2; if(v>9) v-=9; } t+=v; } return t%10===0; };
        var okTva=false;
        if(/^FR[0-9A-Z]{2}\d{9}$/.test(tva)) okTva=luhn(tva.slice(-9));
        else if(/^\d{14}$/.test(tva)) okTva=luhn(tva)||tva.indexOf('356000000')===0;
        else if(/^\d{9}$/.test(tva)) okTva=luhn(tva);
        else if(/^[A-Z]{2}[0-9A-Z]{2,13}$/.test(tva)) okTva=true;
        if(!okTva){ needField('hcat-cl-tva','Diese <b>USt-IdNr. oder Handelsregisternummer</b> scheint nicht korrekt zu sein, können Sie sie prüfen?'); return; }
      }
      document.getElementById('hcat-m-confirm').classList.remove('is-on');
      showStep(2);
    });
    var back1=document.getElementById('hcat-back1');
    if(back1) back1.addEventListener('click',function(e){ e.preventDefault(); showStep(1); });
    var cbBtn=document.getElementById('hcat-order-cb'), virBtn=document.getElementById('hcat-order-vir');
    if(cbBtn) cbBtn.addEventListener('click',function(){ doCheckout('cb', cbBtn); });
    if(virBtn) virBtn.addEventListener('click',function(){ doCheckout('virement', virBtn); });
    var topBtn=document.getElementById('hcat-top');
    if(topBtn){
      window.addEventListener('scroll',function(){
        if(window.scrollY>600) topBtn.classList.add('is-on'); else topBtn.classList.remove('is-on');
      },{passive:true});
      topBtn.addEventListener('click',function(){ window.scrollTo({top:0,behavior:'smooth'}); });
    }
    var navR=document.getElementById('hcat-nav-resume');
    if(navR) navR.addEventListener('click',function(e){ e.preventDefault();
      var rw=document.getElementById('hcat-resume-wrap');
      rw.classList.add('is-open');
      rw.scrollIntoView({behavior:'smooth',block:'center'});
      var ri=document.getElementById('hcat-resume-in'); if(ri) ri.focus();
    });

    /* --- validite d'un devis repris, 17/09/2026 -----------------------------------
       Le client transfere son lien a sa direction pour faire valider le montant. A cet
       instant, ce qui compte n'est pas le detail des lignes mais une seule question :
       est-ce que ce prix tient encore ?

       La duree vient de HOPER_CFG.validite, servie par le metachamp hoper.validite_devis,
       lui-meme pousse depuis plan/canonique.json. Elle n'est recopiee NULLE PART ici :
       le jour ou elle passe de 14 a 21 jours, un nombre fige dans ce fichier mentirait
       au client pendant des semaines.

       La date d'emission vient de _ts, ecrit par le worker a chaque sauvegarde. Les
       devis anterieurs a cette ligne ne l'ont pas : on retombe alors sur la date
       contenue dans le NUMERO (DEV-AAAAMMJJ-...), exactement comme le registre et la
       purge le font cote serveur. Une date reelle, jamais inventee : sans aucune des
       deux, on n'affiche rien plutot qu'une echeance au jugé. */
    function dateDevis(etat, numero){
      var t = etat && etat._ts;
      if(t){ var d = new Date(t); if(!isNaN(d.getTime())) return d; }
      var m = String(numero||'').toUpperCase().match(/^DEV-(\d{4})(\d{2})(\d{2})-/);
      if(m){ var d2 = new Date(+m[1], +m[2]-1, +m[3]); if(!isNaN(d2.getTime())) return d2; }
      return null;
    }
    function montrerValidite(etat, numero){
      var zone = document.getElementById('hcat-validite');
      if(!zone) return;
      var jours = (window.HOPER_CFG && window.HOPER_CFG.validite) || 0;
      var emis = dateDevis(etat, numero);
      if(!jours || !emis){ zone.style.display='none'; return; }
      var fin = new Date(emis.getTime() + jours*24*3600*1000);
      var perime = fin < new Date();
      /* La langue vient du DOCUMENT, jamais d'une variable Liquid : « EN » n'existe
         pas dans ce fichier, c'est une variable de la section du theme. L'y employer
         levait une ReferenceError a l'interieur d'un .then(), donc EN SILENCE : ni le
         client ni sa direction n'auraient jamais vu cette ligne, et le banc serait
         reste vert puisqu'il lit des motifs sans executer une ligne. */
      var enAnglais = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      var jour = fin.toLocaleDateString(enAnglais ? 'en-GB' : 'fr-FR',
                   {day:'2-digit', month:'long', year:'numeric'});
      /* Un devis perime le DIT et reste lisible : on n'efface rien. Une direction qui
         vient de recevoir le lien ne doit pas tomber sur un ecran vide, elle doit
         comprendre en une phrase pourquoi le montant doit etre reconfirme. */
      zone.className = perime ? 'hcat-validite hcat-perime' : 'hcat-validite';
      zone.innerHTML = perime
        ? (enAnglais ? 'This quote is no longer valid since ' + jour
              + '. The selection stays visible; write to us and we will reissue it at today’s prices.'
              : 'Dieses Angebot ist nicht mehr gültig seit dem ' + jour
              + '. Die Auswahl bleibt sichtbar: schreiben Sie uns, und wir erstellen es zu den heutigen Preisen neu.')
        : (enAnglais ? 'This quote is valid until ' + jour + '.'
              : 'Dieses Angebot ist gültig bis zum ' + jour + '.');
      zone.style.display='';
      return perime;
    }

    /* --- bon pour accord, 18/09/2026 ------------------------------------------------
       Charles : « le client valide son devis d'un clic ». Ce qui fait la preuve n'est pas
       une signature dessinee, c'est le faisceau : le LIEN (jeton que seul le destinataire
       possede), le NOM saisi, l'HEURE, et l'EMPREINTE du contenu accepte, posee par le
       worker. Un devis modifie apres coup perd son accord, cote serveur.

       Trois refus volontaires :
         - en mode vendeur, le bouton n'apparait pas : un accord que nous donnerions
           nous-memes ne prouverait rien ;
         - sans jeton (lien devine, devis ouvert sans le lien du client), rien non plus ;
         - sur un devis perime, on n'accepte pas un montant qui ne tient plus. */
    var accordCtx=null;
    function dateAccord(iso){
      var d=new Date(iso); if(isNaN(d.getTime())) return '';
      var enAnglais=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
      return d.toLocaleDateString(enAnglais?'en-GB':'fr-FR',{day:'2-digit',month:'long',year:'numeric'});
    }
    function montrerAccord(etat, numero, jeton, perime){
      var zone=document.getElementById('hcat-accord');
      if(!zone || VENDEUR) return;
      var fait=document.getElementById('hcat-accord-fait'), btn=document.getElementById('hcat-accord-btn');
      var ok=etat && etat._ok;
      if(ok && ok.nom){
        fait.textContent=fait.getAttribute('data-par')+' '+ok.nom
          +(ok.fonction?' ('+ok.fonction+')':'')+' '+fait.getAttribute('data-le')+' '+dateAccord(ok.at);
        fait.hidden=false; btn.hidden=true; zone.hidden=false;
        return;
      }
      if(!jeton || perime) return;
      accordCtx={num:numero, jeton:jeton, total:(etat && etat.totals && etat.totals.total) || 0};
      fait.hidden=true; btn.hidden=false; zone.hidden=false;
    }
    (function(){
      var fen=document.getElementById('hcat-accord-fen'), btn=document.getElementById('hcat-accord-btn');
      if(!fen || !btn) return;
      var msg=document.getElementById('hcat-accord-msg'), fin=document.getElementById('hcat-accord-fin'),
          nomC=document.getElementById('hcat-accord-nom'), fctC=document.getElementById('hcat-accord-fct'),
          caseC=document.getElementById('hcat-accord-case'), ok=document.getElementById('hcat-accord-ok'),
          quoi=document.getElementById('hcat-accord-quoi');
      var fermer=function(){ fen.classList.remove('is-open'); document.documentElement.classList.remove('hcat-fige'); };
      /* 22/09/2026, Charles : « quand on clique sur bon pour accord, il faudrait limite que
         le client recoive la proforma pour pouvoir payer ». On ne l'emet pas d'office (une
         piece comptable que le client n'a pas demandee, et qui bloque la carte) : l'accord
         debouche sur le choix du reglement, avec les deux boutons du parcours existant. */
      var suiteA=document.createElement('div'); suiteA.className='hcat-accord-suite'; suiteA.hidden=true;
      var lib=function(id){ var e=document.querySelector('#'+id+' .hcat-paycard-t'); return e ? (e.textContent||'').trim() : ''; };
      [['cb','hcat-cpt-btn'],['virement','hcat-cpt-btn2']].forEach(function(x){
        var b=document.createElement('button'); b.type='button'; b.className=x[1];
        b.textContent=lib(x[0]==='cb'?'hcat-order-cb':'hcat-order-vir');
        b.addEventListener('click',function(){ fermer(); reglerPar(x[0]); });
        suiteA.appendChild(b);
      });
      if(fin) fin.parentNode.insertBefore(suiteA, fin.nextSibling);
      btn.addEventListener('click',function(){
        if(!accordCtx) return;
        msg.textContent=''; fin.hidden=true; suiteA.hidden=true; ok.hidden=false; ok.disabled=false;
        /* Le montant presente est celui que le client a sous les yeux, pas celui du chargement. */
        var totA=(curDevis && curDevis.num===accordCtx.num) ? ((collectState().totals||{}).total||accordCtx.total) : accordCtx.total;
        quoi.textContent=quoi.getAttribute('data-devis')+' '+accordCtx.num+' · '+euro(totA)+' '+quoi.getAttribute('data-ht');
        fen.classList.add('is-open'); document.documentElement.classList.add('hcat-fige');
        setTimeout(function(){ nomC.focus(); },60);
      });
      document.getElementById('hcat-accord-close').addEventListener('click',fermer);
      surFond(fen,function(){ fermer(); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape' && fen.classList.contains('is-open')) fermer(); });
      ok.addEventListener('click',function(){
        if(!accordCtx) return;
        var nom=(nomC.value||'').trim();
        if(nom.length<3){ msg.textContent=ok.getAttribute('data-nom'); nomC.focus(); return; }
        if(!caseC.checked){ msg.textContent=ok.getAttribute('data-case'); return; }
        msg.textContent=ok.getAttribute('data-envoi'); ok.disabled=true;
        var envoyerAccord=function(){
        fetch(DEVIS_API+'-accord?t='+encodeURIComponent(accordCtx.jeton),
              {method:'POST',headers:{'Content-Type':'application/json'},
               body:JSON.stringify({num:accordCtx.num, nom:nom, fonction:(fctC.value||'').trim()})})
          .then(function(r){ return r.json(); })
          .then(function(d){
            if(!d || !d.ok){ msg.textContent=ok.getAttribute('data-erreur'); ok.disabled=false; return; }
            msg.textContent=''; ok.hidden=true; fin.hidden=false; suiteA.hidden=false;
            nomC.disabled=true; fctC.disabled=true; caseC.disabled=true;
            montrerAccord({_ok:d.accord}, accordCtx.num, accordCtx.jeton, false);
          })
          .catch(function(){ msg.textContent=ok.getAttribute('data-erreur'); ok.disabled=false; });
        };
        /* Un devis repris puis modifie est reecrit AVANT l'accord : l'accord porte alors sur
           ce que le client a sous les yeux, et le serveur le rattache au bon contenu. */
        if(curDevis && curDevis.num===accordCtx.num) ensureDevis(envoyerAccord); else envoyerAccord();
      });
    })();

    /* --- restauration : ?devis=DEV-... (serveur) ou base64, sinon mémoire locale --- */
    (function(){
      var p=null;
      try{ p=new URLSearchParams(location.search).get('devis'); }catch(e){}
      var action=null;
      try{ action=new URLSearchParams(location.search).get('action'); }catch(e){}
      function autoOpen(){
        if(action!=='commander' && action!=='facture') return;
        if(!PRO){ setTimeout(function(){ if(state.lines.length) ouvrirMur(); }, 500); return; }
        setTimeout(function(){
          if(!state.lines.length) return;
          renderModal(); modal.classList.add('is-open');
          if((client.em||'').trim()) showStep(2); else showStep(1);
        }, 500);
      }
      var jetonUrl=''; try{ var mh=(location.hash||'').match(/t=([0-9a-f]{16,64})/i); if(mh){ jetonUrl=mh[1]; } }catch(e){}
      if(p && /^DEV-/i.test(p)){
        fetch(DEVIS_API+'?num='+encodeURIComponent(p.toUpperCase())+(jetonUrl?'&t='+encodeURIComponent(jetonUrl):''))
          .then(function(r){ return r.json(); })
          .then(function(d){
            if(d && d.found && d.state){
              resetAll(); restoreState(d.state);
              /* 17/09/2026, Comptoir tranche 2 : REPRENDRE un devis au lieu d'en tirer
                 un neuf. Jusqu'ici la reprise rechargeait le contenu sans renseigner
                 curDevis : devant un client, changer une quantite puis enregistrer
                 creait un SECOND numero pour une seule discussion.

                 Trois gardes, chacune pour une raison precise :

                 1. d.partiel. Sans jeton, le serveur rend un etat AMPUTE des blocs
                    client, livraison et facturation. S'approprier un tel etat puis
                    enregistrer REECRIRAIT le devis sans les coordonnees du client :
                    une perte de donnees reelle, a un clic.
                 2. jetonUrl. Le jeton ne peut venir que de l'adresse, apres le diese :
                    le serveur ne le rend JAMAIS en lecture. Sans lui, la reecriture
                    serait refusee par la porte posee le 16/09.
                 3. Le mode Comptoir. Pour un client ordinaire, repartir sur un numero
                    neuf reste le bon comportement : c'est ce qui l'empeche de reecrire
                    sans le savoir un devis qu'il n'a pas compose. */
              /* 22/09/2026, reproduit en ligne : le client ouvrait DEV-...-PUD depuis son lien
                 et son premier geste partait sous DEV-...-Z5P. La garde 3 ci-dessus
                 protegeait d'une reecriture a l'aveugle ; avec SON jeton, le lecteur est le
                 destinataire du devis, il le garde donc sous son numero. Les gardes 1 et 2
                 demeurent : sans jeton, ou sur un etat partiel, rien n'est repris. */
              if(!d.partiel && jetonUrl){
                devisRepris = !(window.HOPER_CFG && window.HOPER_CFG.comptoir);
                curDevis={num:(d.num||p).toUpperCase(), now:new Date(),
                          editUrl:location.origin+location.pathname+'?devis='
                                  +encodeURIComponent((d.num||p).toUpperCase())+'#t='+jetonUrl,
                          jeton:jetonUrl};
                showNum(curDevis.num);
              }
              /* 17/09/2026, phase 3 : la validite s'affiche pour TOUT LE MONDE.
                 Elle est posee HORS de la garde ci-dessus, a dessein. Cette garde ne
                 sert qu'a s'approprier le devis au Comptoir ; la validite, elle,
                 interesse d'abord le client et SA DIRECTION, qui ouvre le lien
                 transfere sans compte et doit savoir si le montant tient encore.
                 Un devis presente comme valable alors qu'il est perime, c'est une
                 negociation qui repart de zero devant le client. */
              var perime=montrerValidite(d.state, (d.num||p).toUpperCase());
              montrerAccord(d.state, (d.num||p).toUpperCase(), d.partiel ? '' : jetonUrl, perime===true);
              if(devisRepris && curDevis) poserModeDevis(curDevis.num, perime===true);
              autoOpen();
            }
            else { try{ var loc=JSON.parse(localStorage.getItem('hcat:v1')||'null'); if(loc) restoreState(loc); }catch(e){} }
          })
          .catch(function(){});
        return;
      }
      var initial=null;
      if(p){
        try{ initial=JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(p))))); }
        catch(e){ try{ initial=JSON.parse(decodeURIComponent(escape(atob(p)))); }catch(e2){} }
      }
      if(!initial){ try{ initial=JSON.parse(localStorage.getItem('hcat:v1')||'null'); }catch(e){} }
      if(initial){ restoreState(initial); if(p) autoOpen(); }
    })();
  })();
